<ng-template let-modal #claimReferal>
  <div class="d-flex flex-column justify-content-center align-items-center p-3">
    <div style="font-size: 1.5rem; font-weight: bold; text-decoration: underline" class="mb-4">Enter Shop Promo Code
    </div>
    <div class="d-flex">
      <div class="mr-2" style="border-radius: 50%; overflow: hidden">
        <img src="../../../../../assets/images/w.jpeg" />
      </div>
      <div class="w-100 d-flex justify-content-center flex-column align-items-center">
        <input style="max-width: 20em" type="text" placeholder="Shop Promo Code" class="form-control"
          [(ngModel)]="claimPromoCode" />
        <button (click)="claimCurrentMoreSerive()" class="my-button-3 mt-3"><i class="fa fa-check"></i> Claim</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #productReviewStats>
  <div class="checks-modal">
    <h2 class="mb-4" style="font-size: 1.25rem"><i class="fas fa-chart-bar"></i> Survey Stats</h2>
    <div class="checks">
      <ng-container *ngFor="let field of suggestions; index as i">
        <div class="check"
          *ngIf="productData?.publicReviews[field.name] && (nonFoodIndexes.includes(i) || productIsFood(productData))">
          <div class="icon">
            @if(field.key == "responseTime") {
            <svg viewBox="0 0 800 750" fill="none">
              <path
                d="M574.63 735.382L420.914 469.14C411.6 453.008 420.803 432.483 438.993 428.663C501.004 415.636 551.992 372.596 575.383 313.527C583.789 292.297 613.1 290.105 624.541 309.919L796.279 607.395C807.905 627.532 790.604 652.157 767.702 648.018L660.8 628.69L624.1 730.942C616.269 752.759 586.337 755.665 574.63 735.382Z"
                fill="var(--primary)" />
              <path
                d="M175.902 730.943L139.202 628.692L32.3 648.02C9.41561 652.156 -7.91255 627.551 3.72341 607.396L175.461 309.922C186.902 290.106 216.213 292.302 224.619 313.53C248.01 372.597 298.997 415.64 361.009 428.666C379.238 432.494 388.382 453.046 379.088 469.143L225.372 735.385C213.691 755.617 183.749 752.806 175.902 730.943Z"
                fill="var(--primary)" style="opacity: 0.75" />
              <path
                d="M400 487.415C204.448 487.415 89.2926 268.648 198.855 107.438C295.391 -34.6092 504.672 -34.5358 601.167 107.45C711.2 269.357 594.959 487.415 400 487.415Z"
                fill="#FFD155" />
              <path
                d="M601.165 107.451C552.926 36.4692 476.5 0.953516 400.063 0.931641V487.415C594.984 487.365 711.188 269.34 601.165 107.451Z"
                fill="#FFBE00" />
              <path
                d="M458.108 377.397L400.001 346.849L341.895 377.397C321.851 387.936 298.346 370.866 302.176 348.539L313.273 283.838L266.267 238.016C250.054 222.211 259.018 194.581 281.437 191.325L346.401 181.884L375.454 123.015C385.475 102.711 414.523 102.698 424.55 123.015L453.601 181.883L518.565 191.323C540.972 194.58 549.959 222.2 533.737 238.014L486.728 283.836L497.825 348.538C501.662 370.907 478.086 387.905 458.108 377.397Z"
                fill="#FFE49C" />
              <path
                d="M518.565 191.325L453.601 181.885L424.549 123.017C419.548 112.881 409.812 107.808 400.063 107.786V346.882L458.107 377.398C478.085 387.905 501.662 370.904 497.826 348.54L486.729 283.838L533.739 238.018C549.959 222.202 540.972 194.582 518.565 191.325Z"
                fill="#FFD155" />
            </svg>
            } @if(field.key == "price") {
            <svg viewBox="0 0 140 124" fill="none">
              <path
                d="M90 6.48848C95.9 4.38848 95.8 4.38848 99.2 9.58848C101.6 13.2885 103.3 18.1885 106.7 20.0885C109.9 21.8885 115 20.6885 119.2 20.5885C122.2 20.4885 123.5 21.5885 123.4 24.6885C123.2 28.8885 123.4 33.0885 123.4 37.2885C129.7 38.4885 129.7 38.4885 129.7 45.0885C129.7 51.1885 129.7 57.2885 129.7 63.5885C130.8 63.7885 131.6 63.8885 132.5 63.9885C136.5 64.4885 139 66.8885 139.1 70.8885C139.3 77.4885 139.3 84.0885 139.1 90.7885C139 95.4885 136.8 97.1885 129.8 98.2885C129.8 105.188 129.8 112.188 129.8 119.088C129.8 123.888 129.7 123.988 125.1 123.988C87.4 123.988 49.6 123.988 11.9 123.988C4.29999 123.988 0 119.788 0 112.188C0 85.5885 0 58.9885 0 32.3885C0 24.9885 4.3 20.7885 11.7 20.6885C21.6 20.5885 31.4 20.7885 41.3 20.5885C43.2 20.5885 45.3 19.9885 47 19.1885C58.4 13.2885 69.8 7.28848 81.1 1.08848C84.4 -0.711517 86.3 -0.411524 87.9 2.98848C88.2 4.08848 89.1 5.18848 90 6.48848ZM125.3 97.7885C123.7 97.7885 122.3 97.7885 121 97.7885C109.5 97.7885 98 97.7885 86.5 97.7885C78.7 97.7885 73.6 92.6885 73.4 84.8885C73.3 82.2885 73.3 79.6885 73.4 76.9885C73.6 69.0885 78.7 63.9885 86.7 63.8885C98.2 63.8885 109.7 63.8885 121.2 63.8885C122.5 63.8885 123.9 63.7885 125.4 63.6885C125.4 56.3885 125.4 49.4885 125.4 42.0885C123.7 42.0885 122.3 42.0885 120.8 42.0885C86.6 42.0885 52.3 42.0885 18.1 42.0885C13.6 42.0885 9 41.5885 4.2 41.2885C4.2 41.9885 4.2 43.2885 4.2 44.4885C4.2 66.5885 4.2 88.6885 4.2 110.888C4.2 117.888 6.00001 119.688 13.1 119.688C49.1 119.688 85.1 119.688 121.1 119.688C122.4 119.688 123.8 119.688 125.4 119.688C125.3 112.288 125.3 105.288 125.3 97.7885ZM108.7 68.1885C101.3 68.1885 94 68.0885 86.6 68.1885C80.9 68.2885 77.9 71.3885 77.8 77.0885C77.8 79.5885 77.8 82.0885 77.8 84.5885C77.9 90.0885 80.8 93.3885 86.2 93.4885C101.1 93.5885 115.9 93.5885 130.8 93.5885C133.6 93.5885 134.9 92.3885 134.8 89.4885C134.7 83.8885 134.7 78.2885 134.8 72.5885C134.9 69.3885 133.6 68.0885 130.4 68.0885C123.2 68.2885 116 68.1885 108.7 68.1885ZM94.1 9.58848C76.6 18.8885 59.5 27.9885 41.5 37.5885C65.5 37.5885 88.4 37.5885 112 37.5885C105.9 27.8885 100 18.7885 94.1 9.58848ZM22.4 36.9885C26.6 37.4885 30.7 38.5885 34.8 36.3885C46.2 30.1885 57.7 24.1885 69.1 18.0885C74.8 15.0885 80.4 11.9885 86.4 8.78846C85.3 7.18846 84.5 5.88848 83.6 4.48848C62.8 15.4885 42.6 26.2885 22.4 36.9885ZM34.4 25.7885C34.3 25.4885 34.3 25.2885 34.2 24.9885C26.2 24.9885 18.2 24.6885 10.3 25.1885C8.3 25.2885 5.5 27.3885 4.8 29.2885C4.1 31.0885 4.9 34.3885 6.3 35.8885C7.5 37.1885 10.9 37.9885 12.5 37.1885C20 33.6885 27.2 29.5885 34.4 25.7885ZM118.8 25.1885C115.6 25.1885 112.7 25.1885 109.2 25.1885C112.5 29.6885 114.3 34.4885 118.8 38.5885C118.8 33.4885 118.8 29.4885 118.8 25.1885Z"
                fill="var(--primary)" />
              <path
                d="M125.3 97.7881C125.3 105.388 125.3 112.288 125.3 119.688C123.7 119.688 122.4 119.688 121 119.688C84.9996 119.688 48.9996 119.688 12.9996 119.688C5.8996 119.688 4.09961 117.888 4.09961 110.888C4.09961 88.7881 4.09961 66.6881 4.09961 44.4881C4.09961 43.2881 4.09961 41.9881 4.09961 41.2881C8.89961 41.5881 13.3996 42.0881 17.9996 42.0881C52.1996 42.1881 86.4996 42.0881 120.7 42.0881C122.2 42.0881 123.6 42.0881 125.3 42.0881C125.3 49.4881 125.3 56.4881 125.3 63.6881C123.8 63.7881 122.5 63.8881 121.1 63.8881C109.6 63.8881 98.0996 63.8881 86.5996 63.8881C78.5996 63.8881 73.4996 68.9881 73.2996 76.9881C73.1996 79.5881 73.1996 82.2881 73.2996 84.8881C73.4996 92.6881 78.6996 97.6881 86.3996 97.7881C97.8996 97.8881 109.4 97.7881 120.9 97.7881C122.4 97.7881 123.7 97.7881 125.3 97.7881ZM41.1996 66.8881C46.8996 65.8881 49.0996 67.2881 50.5996 72.1881C50.8996 73.0881 52.0996 73.7881 52.7996 74.5881C53.3996 73.5881 54.4996 72.4881 54.4996 71.4881C54.4996 67.0881 50.4996 63.0881 45.9996 62.4881C44.3996 62.2881 42.7996 62.1881 42.2996 62.1881C40.8996 59.6881 39.7996 57.7881 38.7996 55.9881C37.6996 57.8881 36.5996 59.8881 35.2996 62.1881C26.5996 63.3881 22.9996 65.8881 22.8996 71.7881C22.8996 74.0881 23.5996 76.7881 24.6996 78.7881C27.1996 83.0881 31.8996 83.0881 36.0996 83.1881C36.0996 87.5881 36.0996 91.4881 36.0996 95.2881C29.8996 95.5881 28.7996 94.7881 26.6996 89.2881C26.3996 88.4881 25.2996 87.8881 24.4996 87.1881C23.8996 88.0881 22.7996 88.9881 22.7996 89.9881C22.5996 94.3881 26.5996 98.7881 31.2996 99.3881C32.8996 99.5881 34.4996 99.5881 35.1996 99.6881C36.4996 102.188 37.4996 104.088 38.4996 105.988C39.5996 104.088 40.7996 102.188 42.1996 99.7881C51.0996 98.2881 54.6996 95.6881 54.4996 89.4881C54.3996 87.2881 53.8996 84.1881 52.2996 82.9881C49.0996 80.5881 45.1996 79.2881 40.9996 77.1881C41.1996 74.4881 41.1996 70.6881 41.1996 66.8881Z"
                fill="white" />
              <path
                d="M108.7 68.1881C115.9 68.1881 123.2 68.2881 130.4 68.1881C133.6 68.1881 134.9 69.3881 134.8 72.6881C134.6 78.2881 134.7 83.8881 134.8 89.5881C134.9 92.4881 133.6 93.6881 130.8 93.6881C115.9 93.6881 101.1 93.7881 86.1998 93.5881C80.7998 93.4881 77.7998 90.1881 77.7998 84.6881C77.7998 82.1881 77.7998 79.6881 77.7998 77.1881C77.8998 71.4881 80.8998 68.3881 86.5998 68.2881C93.9998 68.0881 101.3 68.1881 108.7 68.1881ZM95.4998 90.1881C100.6 90.0881 104.8 85.9881 104.8 80.8881C104.8 75.6881 100.5 71.4881 95.1998 71.5881C90.0998 71.6881 85.9998 75.7881 85.9998 80.8881C85.8998 86.0881 90.1998 90.2881 95.4998 90.1881Z"
                fill="#95a5a6" />
              <path
                d="M94.1 9.58887C100 18.8889 105.8 27.9889 112 37.5889C88.5 37.5889 65.5 37.5889 41.5 37.5889C59.5 27.8889 76.7 18.7889 94.1 9.58887Z"
                fill="white" />
              <path
                d="M22.4004 36.9889C42.6004 26.2889 62.9004 15.4889 83.5004 4.58887C84.4004 5.88887 85.2004 7.18885 86.3004 8.88885C80.4004 12.0889 74.7004 15.0889 69.0004 18.1889C57.6004 24.2889 46.1004 30.2889 34.7004 36.4889C30.6004 38.5889 26.6004 37.4889 22.4004 36.9889Z"
                fill="white" />
              <path
                d="M34.4004 25.7881C27.2004 29.5881 20.0004 33.6881 12.6004 37.0881C11.0004 37.8881 7.60041 37.0881 6.40041 35.7881C5.00041 34.2881 4.20041 30.9881 4.90041 29.1881C5.60041 27.3881 8.40041 25.1881 10.4004 25.0881C18.3004 24.5881 26.3004 24.8881 34.3004 24.8881C34.3004 25.1881 34.4004 25.4881 34.4004 25.7881Z"
                fill="white" />
              <path
                d="M118.8 25.1885C118.8 29.4885 118.8 33.5885 118.8 38.5885C114.3 34.5885 112.5 29.6885 109.2 25.1885C112.7 25.1885 115.6 25.1885 118.8 25.1885Z"
                fill="white" />
              <path
                d="M41.1999 66.8883C41.1999 70.6883 41.1999 74.4883 41.1999 77.1883C45.3999 79.1883 49.2999 80.5883 52.4999 82.9883C53.9999 84.0883 54.5999 87.1883 54.6999 89.4883C54.8999 95.5883 51.2999 98.2883 42.3999 99.7883C40.8999 102.188 39.7999 104.088 38.6999 105.988C37.6999 104.088 36.6999 102.188 35.3999 99.6883C34.6999 99.5883 33.0999 99.5883 31.4999 99.3883C26.7999 98.7883 22.6999 94.4883 22.9999 89.9883C23.0999 88.9883 24.0999 88.1883 24.6999 87.1883C25.3999 87.8883 26.5999 88.3883 26.8999 89.2883C28.9999 94.7883 30.0999 95.5883 36.2999 95.2883C36.2999 91.3883 36.2999 87.4883 36.2999 83.1883C31.9999 83.1883 27.3999 83.0883 24.8999 78.7883C23.6999 76.7883 22.9999 74.0883 23.0999 71.7883C23.1999 65.8883 26.7999 63.3883 35.4999 62.1883C36.7999 59.8883 37.8999 57.9883 38.9999 55.9883C39.9999 57.8883 41.0999 59.6883 42.4999 62.1883C43.0999 62.1883 44.6999 62.2883 46.1999 62.4883C50.6999 63.0883 54.6999 67.0883 54.6999 71.4883C54.6999 72.4883 53.5999 73.5883 52.9999 74.5883C52.1999 73.7883 51.0999 73.1883 50.7999 72.1883C49.0999 67.2883 46.8999 65.8883 41.1999 66.8883ZM41.1999 95.0883C44.5999 95.5883 47.5999 95.2883 49.5999 92.2883C51.0999 89.9883 50.9999 87.4883 49.1999 85.3883C47.0999 82.7883 44.2999 82.4883 41.1999 83.3883C41.1999 87.3883 41.1999 91.1883 41.1999 95.0883ZM36.3999 66.6883C32.7999 66.1883 29.3999 66.2883 27.9999 69.5883C27.1999 71.3883 27.3999 74.3883 28.2999 76.0883C29.8999 78.9883 33.0999 79.0883 36.3999 78.5883C36.3999 74.5883 36.3999 70.7883 36.3999 66.6883Z"
                fill="var(--primary)" />
              <path
                d="M95.5004 90.1887C90.2004 90.2887 85.9004 86.0887 85.9004 80.8887C85.9004 75.7887 90.0004 71.6887 95.1004 71.5887C100.4 71.4887 104.7 75.6887 104.7 80.8887C104.7 85.9887 100.6 90.0887 95.5004 90.1887ZM95.4004 75.7886C92.5004 75.7886 90.4004 77.7887 90.3004 80.5887C90.2004 83.5887 92.3004 85.7886 95.3004 85.7886C98.3004 85.7886 100.5 83.5887 100.4 80.6887C100.3 77.8887 98.2004 75.8886 95.4004 75.7886Z"
                fill="var(--primary)" />
              <path
                d="M41.2002 95.0881C41.2002 91.1881 41.2002 87.3881 41.2002 83.2881C44.2002 82.3881 47.0002 82.7881 49.2002 85.2881C51.0002 87.3881 51.1002 89.8882 49.6002 92.1882C47.7002 95.2882 44.7002 95.5881 41.2002 95.0881Z"
                fill="white" />
              <path
                d="M36.4001 66.6886C36.4001 70.7886 36.4001 74.5886 36.4001 78.6886C33.1001 79.1886 29.9001 79.0886 28.3001 76.1886C27.3001 74.3886 27.2001 71.4886 28.0001 69.6886C29.5001 66.2886 32.8001 66.0886 36.4001 66.6886Z"
                fill="white" />
              <path
                d="M95.3997 75.7881C98.1997 75.7881 100.4 77.8881 100.4 80.6881C100.5 83.6881 98.2997 85.8881 95.2997 85.7881C92.2997 85.7881 90.0997 83.4881 90.2997 80.5881C90.3997 77.7881 92.4997 75.7881 95.3997 75.7881Z"
                fill="white" />
            </svg>
            } @if(field.key == "pleasantXP"){
            <svg viewBox="0 0 209 191" fill="none">
              <path
                d="M48.5156 164.589C41.8156 152.689 35.2156 141.189 28.5156 129.289C30.0156 128.389 31.2156 127.589 32.5156 126.789C42.2156 121.189 52.0156 115.689 61.7156 109.989C68.9156 105.789 76.1156 105.489 84.0156 108.089C96.5156 112.289 109.216 115.889 121.816 119.689C126.216 120.989 128.716 124.689 127.916 128.989C127.216 132.789 124.016 135.489 119.616 134.689C113.416 133.689 107.216 131.889 101.116 130.289C98.0156 129.489 94.9156 128.289 91.7156 127.989C90.5156 127.889 88.2156 129.289 87.9156 130.389C87.6156 131.489 88.9156 134.189 89.9156 134.389C102.016 137.389 114.016 140.489 126.316 142.789C132.616 143.989 138.616 141.689 144.116 138.389C157.116 130.689 170.116 122.989 183.316 115.689C187.716 113.189 192.516 111.189 197.416 110.089C205.116 108.289 210.516 114.089 208.216 121.389C207.616 123.189 206.116 125.089 204.416 126.189C180.616 140.889 156.816 155.489 133.016 170.089C126.216 174.289 119.016 175.389 111.116 173.089C95.3156 168.589 79.3156 164.589 63.5156 160.189C59.6156 159.089 56.2156 159.089 53.0156 161.689C51.7156 162.989 50.2156 163.589 48.5156 164.589Z"
                fill="black" />
              <path
                d="M178.016 11.2891C167.416 23.8891 156.916 36.1891 145.916 49.1891C141.916 44.8891 138.216 40.7891 134.316 36.9891C127.816 30.5891 118.416 30.2891 112.516 36.1891C106.216 42.4891 106.416 51.3891 113.116 58.1891C120.616 65.6891 128.116 73.1891 135.616 80.6891C142.216 87.2891 151.616 87.3891 157.816 80.3891C169.816 66.6891 181.516 52.6891 193.416 38.7891C194.216 37.8891 195.016 36.9891 195.916 35.9891C203.816 53.7891 199.716 82.8891 175.816 99.1891C152.316 115.289 120.216 110.389 102.416 88.0891C85.1159 66.4891 87.1159 34.6891 107.016 15.4891C127.716 -4.61089 158.716 -4.2109 178.016 11.2891Z"
                fill="var(--primary)" style="opacity: 0.75" />
              <path
                d="M146.315 59.2889C151.815 52.7889 156.615 47.1889 161.515 41.4889C172.115 28.8889 182.815 16.3889 193.415 3.78888C195.715 0.988881 198.515 -0.711119 202.215 0.288881C208.315 1.78888 210.315 8.6889 206.115 13.5889C194.515 27.2889 182.815 40.9889 171.115 54.5889C165.315 61.3889 159.415 68.1889 153.415 74.8889C149.215 79.5889 144.615 79.7889 140.115 75.3889C132.715 68.0889 125.415 60.7889 118.115 53.4889C114.215 49.5889 113.815 44.5889 117.215 41.1889C120.515 37.7889 125.515 37.9889 129.415 41.9889C135.015 47.4889 140.415 53.1889 146.315 59.2889Z"
                fill="var(--primary)" />
              <path
                d="M14.2157 119.989C15.0157 121.089 16.1157 122.189 16.9157 123.489C26.3157 139.989 35.6157 156.389 45.0157 172.889C46.2157 175.089 47.4157 177.289 48.7157 179.389C50.0157 181.589 49.5157 183.089 47.3157 184.289C44.4157 185.789 41.5157 187.289 38.8157 189.089C35.9157 190.989 34.2157 190.189 32.6157 187.289C23.8157 171.489 14.8157 155.889 5.81571 140.089C4.11571 137.089 2.4157 133.989 0.615702 130.989C-0.584298 128.889 0.0157113 127.489 2.01571 126.389C5.31571 124.589 8.51571 122.689 11.8157 120.889C12.4157 120.689 13.0157 120.489 14.2157 119.989ZM12.8157 128.089C12.2157 128.089 11.6157 128.089 11.0157 127.989C9.91571 129.489 8.0157 130.989 8.1157 132.389C8.1157 133.689 10.0157 135.789 11.5157 136.189C13.8157 136.789 15.8157 135.189 15.6157 132.689C15.4157 131.189 13.8157 129.689 12.8157 128.089Z"
                fill="black" />
              <path
                d="M12.8156 128.089C13.7156 129.689 15.3156 131.089 15.5156 132.789C15.8156 135.289 13.7156 136.889 11.4156 136.289C10.0156 135.889 8.01562 133.889 8.01562 132.489C8.01562 130.989 9.91562 129.489 10.9156 128.089C11.6156 128.089 12.2156 128.089 12.8156 128.089Z"
                fill="white" />
            </svg>
            } @if(field.key == "location"){
            <svg viewBox="0 0 749 800" fill="none">
              <path
                d="M748.393 124.321H689.739V326.114H713.19V418.773H668.614V112.604C668.631 50.409 618.205 0 556.009 0H185.319C123.141 0 72.7147 50.409 72.7147 112.604V412.906H34.0053V314.345H58.6369V112.604H0V314.345H24.6317V422.314H72.7147V642.854C72.7147 685.451 96.4263 722.581 131.369 741.693V799.983H229.896V755.441H509.072V800H607.633V742.821C643.843 724.143 668.614 686.389 668.614 642.836V428.129H722.581V326.096H748.393V124.321ZM241.647 23.4339H504.385V84.4663H241.647V23.4339ZM269.785 638.132H124.339V572.482H269.785V638.132ZM621.694 638.132H476.247V572.482H621.694V638.132ZM621.694 426.984C621.694 426.984 593.538 516.154 368.329 516.154C143.086 516.154 119.617 426.984 119.617 426.984V117.274H621.694V426.984Z"
                fill="var(--primary)" />
            </svg>
            }
          </div>
          <!-- {{field.key}} -->
          <div>
            <div class="title">
              @if (field.isRough) {
              {{ field.options[productData?.publicReviews[field.name] - 1].split(" ").slice(0, 2).join(" ") }}
              ({{ productData?.publicReviews[field.name + "Count"] }}/{{ productData?.totalCount }})

              <div class="is-yes-no">
                <i class="fa fa-check"></i>
              </div>

              } @else if (field.isYesNo) {
              {{ field.choiceOutput.split(" ").slice(0, 2).join(" ") }}
              ({{ productData?.publicReviews[field.name + "Count"] }}/{{ productData?.totalCount }}) @if
              (productData?.publicReviews[field.name] == 1) {
              <div class="is-yes-no">
                <i class="fa fa-check"></i>
              </div>
              } @else {
              <div class="is-yes-no no">
                <i class="fa fa-x"></i>
              </div>
              } }
            </div>
            <div class="desc">{{ field.title }}</div>
            <div class="mt-1 percentage-outter">
              <div class="percentage-inner" style="background-color: var(--primary)"
                [ngStyle]="{ width: (productData?.publicReviews[field.name + 'Count'] / productData?.totalCount) * 100 + '%' }">
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- <div class="checks" style="grid-auto-flow: row">
      <ng-container *ngFor="let field of suggestions; index as i">
        <span class="check d-flex justify-content-start" style="width: auto !important" *ngIf="productData?.publicReviews[field.name + 'Count'] && (nonFoodIndexes.includes(i) || productIsFood(productData))">
          @if (field.isRough) {

          <div class="w-100 d-flex flex-column align-items-center mb-2 shadow-sm">
            <span>
              <i class="fa fa-check mr-1"></i>
              {{ field.options[productData?.publicReviews[field.name] - 1].split(" ").slice(0, 2).join(" ") }}
              ({{ productData?.publicReviews[field.name + "Count"] }}/{{ productData?.totalCount }})
            </span>

            <div class="ml-2 percentage-outter">
              <div class="percentage-inner" [ngStyle]="{ width: (productData?.publicReviews[field.name + 'Count'] / productData?.totalCount) * 100 + '%' }"></div>
            </div>
          </div>

          } @else if (field.isYesNo) {

          <div class="w-100 d-flex flex-column align-items-center mb-2 shadow-sm">
            <span>
              @if (productData?.publicReviews[field.name] == 1) {
              <i class="fa fa-check mr-1"></i>
              } @else {
              <i class="fa fa-x mr-1"></i>
              }
              {{ field.choiceOutput.split(" ").slice(0, 2).join(" ") }}
              ({{ productData?.publicReviews[field.name + "Count"] }}/{{ productData?.totalCount }})
            </span>
            <div class="ml-2 percentage-outter">
              <div class="percentage-inner" [ngStyle]="{ width: (productData?.publicReviews[field.name + 'Count'] / productData?.totalCount) * 100 + '%' }"></div>
            </div>
          </div>

          }
        </span>
      </ng-container>
    </div> -->
  </div>
</ng-template>

<ng-template #prodReviews>
  <app-my-carousel-swiper [navigation]="productData?.recommendedPins ? true : false"
    *ngIf="!isLoading && (productData?.recommendedPins || productData?.ratings?.length || productData?.otherRatingBadges?.length)"
    [config]="carouselOptions" class="transparent-swiper">
    <ng-container *ngIf="productData?.recommendedPins && !isShowingReviewModal">
      <div class="swiper-slide" *ngFor="let pin of productData?.recommendedPins ?? []">
        <div class="experience" (click)="openRecommendation(pin)">
          <div class="text" style="display: inline">{{ pin.message }}</div>
          <button class="ml-1" (click)="$event.stopPropagation(); isReading ? pause() : read(pin.message)"
            style="background: transparent; border: 0px; color: var(--secondary); font-size: 0.8em; font-weight: bold; width: 2rem; height: 2rem; display: inline-flex; justify-content: center; align-items: center">
            @if (isReading) {
            <i class="fa-solid fa-pause"></i>
            } @else {
            <i class="fa-solid fa-play"></i>
            }
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="productData?.ratings?.length || productData?.otherRatingBadges?.length">
      <div class="swiper-slide position-relative" (touchstart)="$event.stopPropagation()"
        style="overflow: hidden; overflow-x: scroll">
        <div class="all-reviews" *ngIf="productData">
          <ng-container *ngFor="let rating of productData?.ratings">
            <div class="seller-info" *ngIf="rating.rating || rating.counts"
              (click)="isShowingReviewModal ? '' : openCorrectedSite(rating.ratingUrl)">
              <div></div>
              <img [src]="'../../../../../assets/images/' + rating.icon" class="rating-img" style="width: 2.5rem" />
              <div class="rating">{{ rating.rating | number : "1.1-1" || 0 }}</div>
              <div class="star-rating">
                <div class="stars-outer">
                  <div class="stars-inner" [style.width.%]="(rating.rating / 5) * 100"></div>
                </div>
              </div>
              <div class="rating-name">
                <span class="number">
                  {{ rating.counts || 0 }}
                </span>
                <span>Reviews</span>
              </div>
              <div class="d-flex flex-column align-items-start mt-2" style="gap: 0.5em" *ngIf="isShowingReviewModal">
                <input type="number" [(ngModel)]="reviewsRatingSuggestion[rating.id + 'Rating']"
                  (change)="setSuggestedRating($event, rating.id)" placeholder="Suggest Rating Value"
                  class="form-control" />
                <input type="number" [(ngModel)]="reviewsRatingSuggestion[rating.id + 'Count']"
                  (change)="setSuggestedCount($event, rating.id)" placeholder="Suggest Rating Count"
                  class="form-control" />
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isShowingReviewModal">
            <ng-container *ngFor="let rating of productData?.otherRatingBadges">
              <div class="seller-info position-relative" [class.mb-3]="rating.isNormalBadge && !isVerySmall"
                *ngIf="rating.rating || rating.text || rating.isNormalBadge" [ngbTooltip]="rating.toolTip"
                container="body" tooltipClass="my-tooltip tooltip-above">
                <img [class.rating-img]="!rating.isNormalBadge" [class.normal-badge]="rating.isNormalBadge"
                  [src]="'../../../../../assets/images/' + rating.icon" style="width: 2.5rem; height: 3.5rem" />
                @if (rating.isNormalBadge) {
                <div class="d-flex flex-column align-items-center position-relative normal-badges">
                  <div class="seller-info-top-text">
                    {{ rating.topText }}
                  </div>
                  <div class="seller-info-bottom-text">
                    {{ rating.bottomText }}
                  </div>
                </div>
                } @else {
                <div class="position-relative d-flex flex-column align-items-center" style="top: -0.25rem">
                  <div class="rating">{{ rating.rating | number : "1.1-1" || 0 }}</div>
                  <div class="star-rating">
                    <div class="stars-outer">
                      <div class="stars-inner" [style.width.%]="(rating.rating / 5) * 100"></div>
                    </div>
                  </div>
                  <div class="rating-name position-relative">
                    {{ rating.text }}
                  </div>
                </div>
                }
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </app-my-carousel-swiper>
</ng-template>
<ng-template #seeProductList let-modal>
  <p class="mb-4 p-2 w-100" style="font-size: 1.4rem; font-weight: bold; text-align: center"><i
      [class]="productListIcons"></i>{{ productListTitle }}</p>

  <div class="prods p-4">
    <ng-container *ngFor="let list of searchProds">
      <common-product-card-view [isSelected]="true" [canBeSelected]="isSearchProductsOnBookmark"
        (selected)="searchProductSelected($event, list)" (view)="goToProduct($event)" [list]="list"
        [isCommunityProduct]="true"> </common-product-card-view>
    </ng-container>
  </div>
  <p *ngIf="searchProds.length < 1" class="p-3" style="text-align: center; color: var(--primary)"><i
      class="fas fa-heart-broken"></i> No products found in this category</p>
  <button class="btn btn-outline-primary m-3 btn-sm" (click)="closeActiveModal()">Close</button>
</ng-template>

<ng-template let-modal #addAdsInProduct>
  <div class="add-ads-in-product">
    <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="my-modal__body">
      <div class="add-ads-in-product__image">
        <app-icon-selector (iconChange)="newPromoIconText = $event"
          style="position: absolute; top: 0.5rem; left: 0.5rem; font-size: 1.5rem" [nowValue]="newPromoIconText"
          [icons]="moreServiceIcons"></app-icon-selector>

        <!-- Image Display Conditions -->
        <ng-container *ngIf="newPromotSelectedImageConverted; else defaultImage">
          <img [src]="newPromotSelectedImageConverted" (click)="selectMoreImageNewPromoImage()" />
          <!-- <span class="delete-img">
            <i class="fa fa-trash" (click)="deleteNewPromoImage()" aria-hidden="true"></i>
          </span> -->
        </ng-container>

        <ng-template #defaultImage>
          <img src="../../assets/images/uploadd2.png" (click)="selectMoreImageNewPromoImage()" />
        </ng-template>

        <input type="file" (change)="setImageOfMoreService($event)" [id]="newPromoImageSelectorId" />
      </div>

      <input maxlength="40" (change)="newPromoServiceComment = $event.target.value" [value]="newPromoServiceComment"
        class="form-control mb-2" rows="2" placeholder="Enter Information about the service." />
      <textarea maxlength="255" (change)="newPromoServiceDescription = $event.target.value"
        placeholder="Enter more description about the service." class="form-control mb-2 mt-2" rows="2"
        style="height: 10em">{{ newPromoServiceDescription }}</textarea>
      <div class="d-flex justify-content-between align-items-center">
        <label for="select-expiry" style="color: var(--primary); margin-bottom: 0">Select Expiry:</label>
        <select (change)="expiryStringChanged($event, i)" class="select-expiry">
          <option *ngFor="let val of availableExpiryIntervals" class="p-2" [value]="val"
            [selected]="val == newPromoExpiryInString">
            {{ val }}
          </option>
        </select>
      </div>
      <div>
        <input type="checkbox" class="mr-2" id="allowRefer" [checked]="newPromoAllowRefer"
          (change)="newPromoAllowRefer = $event.target.checked" />
        <label for="allowRefer">Allow users to refer this product</label>
      </div>
      <input *ngIf="newPromoAllowRefer" (change)="newPromotReferAmount = $event.target.value"
        [value]="newPromotReferAmount" type="number" placeholder="$" class="mt-1 mb-1 form-control" />
      <button type="button" class="d-flex ml-auto my-button-3" (click)="saveNewPromoOnProduct()">Save</button>
    </div>
  </div>
</ng-template>

<ng-template let-modal #whyReferExplanation cla>
  <div class="w-100 h-100 d-flex flex-column justify-content-start p-4 refer-explanation-modal">
    <p class="w-100 title">You need to refer some friend before claiming this service</p>
    <div class="w-100 d-flex">
      <div class="mr-2" style="border-radius: 50%; overflow: hidden">
        <img src="../../../../../assets/images/w.jpeg" />
      </div>
      <div class="p-3 steps">
        <p class="mb-1" style="font-weight: bold">Inorder to claim services you need to refer(send your referal link) to
          users and they must claim</p>
        <p class="mb-2">Here are the step to claim a service:</p>
        <div>
          <p>1&#41; Send the referal link below to your friends</p>
          <p>2&#41; For each friend that claim the a service using your link you get a chance to claim a service!</p>
        </div>

        <div class="d-flex justify-content-center flex-column align-items-start mt-2">
          <span style="padding: 1em 2em; border: 3px dashed var(--primary); color: black; border-radius: 10px"
            class="mb-4"> {{ getMoreServiceRefferalLink(productData) }}</span>
          <div class="d-flex w-100 justify-content-center" style="font-size: 0.8em">
            <button (click)="copy(getMoreServiceRefferalLink(productData))" class="my-button-3 mr-2"><i
                class="fa fa-copy"></i> Copy</button>
            <button (click)="share(getMoreServiceRefferalLink(productData))" class="my-button"><i
                class="fa-brands fa-whatsapp"></i> Share</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="custom-swiper-1">
  <app-my-carousel-swiper cssClass="custom-swiper-1" (onSlideChange)="productSwiperChanged($event)">
    <div class="swiper-slide">
      <div *ngTemplateOutlet="productDetailsTempalte; context: { productData: productData }"></div>
    </div>
    <div class="swiper-slide" *ngFor="let prod of similarProducts">
      <div *ngTemplateOutlet="productDetailsTempalte; context: { productData: prod }"></div>
    </div>
  </app-my-carousel-swiper>

  <app-marketplace #marketplace *ngIf="showingPop" [share]="true"></app-marketplace>
</div>

<ng-template let-productData="productData" #productDetailsTempalte>
  <div class="modal-body my-prod-detail" id="wrapper" style="position: relative">
    <span *ngIf="productData && (productData['attachmentProducts'] || productData?.prevProduct)" class="attach-item"> <i
        class="fa fa-plus" aria-hidden="true"></i>2</span>
    <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="my-prod-detail__favorite" (click)="handleFavoriteProduct(productData)">
        <i [class]="productData?.isFavorite ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"></i>
      </div>

      <div class="my-prod-detail__body product_detail_body {{ productData?.appUser?.bgBody ?? '' }}">
        <div class="grid-image">
          <div style="position: relative; overflow: hidden">
            @if (isThereValidCropInformation && productData?.food_image_active == productData?.food_image_1) {
            <app-cropped-image [imgSrc]="imgUrl + productData?.food_image_active"
              [cropInformation]="productData?.mainImageCropInformation" [imgAlt]="'Image ' + productData.name"
              (click)="viewProductDetails(productData)"></app-cropped-image>
            } @else {
            <img loading="lazy" class="main-image" [src]="imgUrl + productData?.food_image_active"
              (error)="handleError($event)" />
            }
            <div *ngIf="productData?.productMoreServices && productData?.productMoreServices?.length">
              <img src="../../../../../assets/images/promo.png"
                style="height: 2rem; width: auto; position: absolute; right: 0.25rem; top: 0.75rem" />
            </div>
            <!-- <div *ngIf="isVerified" class="verified" [class.verified-special]="specialTags.has(productData?.verifiedTag?.trim())">
              <span [style]="verifiedStyle" class="d-flex align-items-center" (click)="moduloIncreaseVerifiedRating()">
                <span>{{ verifiedTag | titlecase }}</span>
                <div class="rhoumbus-outer" style="font-size: 0.9em" [class.i-rh]="specialTags.has(productData?.verifiedTag?.trim())">
                  <div class="rhoumbus-inner" [style.width.%]="(productData?.verifiedTagRating / 3) * 100"></div>
                </div>
              </span>
            </div> -->
          </div>

          <div class="slide-images">
            <ng-container
              *ngFor="let image of [productData?.food_image_1, productData?.food_image_2, productData?.food_image_3, productData?.food_image_4]">
              <div *ngIf="image != ''" (click)="changeShowImageProduct(productData, image)"
                (error)="handleError($event)" [ngStyle]="{ 'background-image': 'url(' + imgUrl + image + ')' }"></div>
            </ng-container>
            <ng-container
              *ngIf="(!productData?.food_image_1 || !productData?.food_image_2 || !productData?.food_image_3 || !productData?.food_image_4) && isLogin">
              <button class="btn btn-outline-primary" style="font-size: 1.5rem"
                (click)="$event.stopPropagation(); openSuggestChangeModal(true)">
                <i class="fa fa-plus"></i>
              </button>
            </ng-container>
          </div>
        </div>
        <div class="my-prod-detail__body--content">
          <div *ngIf="productLoader; else productDetail" class="d-flex flex-column justify-content-center text-center">
            <div class="spinner-border text-primary mx-auto" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            Loading...
          </div>
          <ng-template #productDetail>
            <div class="row">
              <div class="col-md-12">
                <div class="my-prod-detail__body--content__title flex-column"
                  style="margin-bottom: 0.75rem; position: relative">
                  <div class="shop_name w-100">
                    <div class="text-left ml-1" style="font-size: 0.8em; color: var(--secondary); cursor: pointer"
                      *ngIf="productData?.hasCrown">Popular in {{ this.productData?.subRegionName?.trim() ?? "Subregion"
                      }} ({{ productData?.foodFavoritesCount }} Upvoted)</div>
                    <div class="d-flex w-100 justifiy-content-start">
                      <h1 class="text w-100 overflow-hidden mb-2 justify-content-between d-flex" style="font-size: 1em"
                        [ngbTooltip]="screenWidth > 767 ? 'Go to ' + productData?.name + ' Detail' : null"
                        style="cursor: pointer" (click)="openProductPage(productData)" tooltipClass="my-tooltip">
                        @if (productData?.companyName?.trim() && productData?.companyName != "null") {
                        <div class="d-flex justify-content-between mx-1">
                          <div class="d-flex flex-column" style="gap: 0.3rem">
                            <div style="line-height: unset">
                              <ng-container *ngIf="productData?.companyName && productData?.companyName != 'null'">
                                <span class="company-name-word"
                                  *ngFor="let word of productData?.companyName?.split(' ')"> {{ word }}</span>
                              </ng-container>
                            </div>

                            <span class="prod-name" style="font-size: 0.8rem; line-height: 1">{{ productData?.name
                              }}</span>
                          </div>
                        </div>
                        } @else {
                        <span class="prod-name">{{ productData?.name }}</span>
                        }

                        <span class="price" *ngIf="productData?.type != 'promote'">{{
                          priceCheck(productData?.foodSpecs?.[0]?.key || "0") }}</span>
                      </h1>
                      <div class="ml-2" style="font-size: 0.8em; color: var(--primary); cursor: pointer"
                        *ngIf="showReferProductIcon && isLogin" id="refer-btn"
                        (click)="openShareReferLink(productData)">
                        <!-- <img style="width: 2em" src="../../../../assets/images/new/refer_friend_new.png" /> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="detail-text">
                  <app-my-tabs [tabs]="productData?.tabsInfo" (tabChange)="clickTab($event)" design="4">
                    <!-- Info -->
                    <div class="mb-2" tab0>
                      <div *ngIf="productData?.tags?.length || productData?.productTypes?.size">
                        <ng-container *ngFor="let tag of productData.tags">
                          <button *ngIf="tag.addCount"
                            (click)="isLogin ? (tag.isAddedByMe ? removeTagFromProduct(tag) : addTagToProduct(tag)) : showLoginError('add a tag')"
                            [class.active]="tag.isAddedByMe" class="btn btn-outline-primary btn-sm mr-1 mt-1">{{ tag.tag
                            }}</button>
                        </ng-container>
                        <ng-container *ngFor="let type of productData.currentProductCategoryAvailableTypes">
                          <button (click)="openSimilarProducs(type)" *ngIf="productData.productTypes.has(type.id)"
                            class="btn btn-outline-primary btn-sm mr-1 mt-1"
                            style="border-color: var(--secondary); color: var(--secondary)">
                            {{ type.name }}
                            <h2 class="d-none">{{ type.name }}</h2>
                          </button>
                        </ng-container>
                        <!-- <button  class="btn btn-outline-primary btn-sm" (click)="openSuggestionPopupAndRefresh()">Add Tag</button> -->
                      </div>
                      <div class="checks-wrapper" *ngIf="productData?.publicReviews" (click)="seeProductReviewStats()">
                        <span class="title-header">Highlights:</span>
                        <div class="checks">
                          <ng-container *ngFor="let field of suggestions; index as i">
                            <span class="check"
                              *ngIf="productData?.publicReviews[field.name] && (nonFoodIndexes.includes(i) || productIsFood(productData))">
                              @if (field.isRough) {
                              <i class="fa fa-check mr-1"></i>
                              {{ field.options[productData?.publicReviews[field.name] - 1].split(" ").slice(0, 2).join("
                              ") }}
                              }@else if(field.isDisplayOption){
                              <i class="fa fa-check mr-1"></i>
                              {{ field.displayOptions[productData?.publicReviews[field.name] - 1].split(" ").slice(0,
                              2).join(" ") }}
                              }
                              @else if (field.isYesNo) {
                              @if (productData?.publicReviews[field.name] == 1) {
                              <i class="fa fa-check mr-1"></i>
                              } @else {
                              <i class="fa fa-x mr-1"></i>
                              }
                              {{ field.choiceOutput.split(" ").slice(0, 2).join(" ") }}
                              }
                            </span>
                          </ng-container>
                        </div>
                      </div>
                      <!-- <div class="mb-5"></div> -->
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <div class="title-header">
                          <span *ngIf="productData?.productVerficationsList?.length" style="display: flex; gap: 0.5em">
                            Verified
                            <span *ngIf="isVerified" class="d-inline-flex align-items-center"
                              (click)="moduloIncreaseVerifiedRating()">
                              <!-- <span>{{ verifiedTag | titlecase }}</span> -->
                              <div class="rhoumbus-outer" style="font-size: 1.25em"
                                [class.i-rh]="specialTags.has(productData?.verifiedTag?.trim())">
                                <div class="rhoumbus-inner"
                                  [style.width.%]="(productData?.verifiedTagRating / 3) * 100"></div>
                              </div>
                            </span>
                          </span>
                        </div>
                        <div class="d-flex w-100 justify-content-end mt-2">
                          <button class="btn btn-primary d-flex align-items-center"
                            style="background-color: var(--primary); gap: 0.5em; font-size: 0.8rem" *ngIf="isLogin"
                            (click)="$event.stopPropagation(); openSuggestChangeModal()">
                            <span> Contribute & Earn {{ reviewAllocatedReward }} <img
                                src="../../../assets/images/gold-coin.png" style="width: 1.2rem; height: 1.2rem" />
                            </span>
                          </button>
                        </div>

                        <span *ngIf="productData?.updated && !isLogin"
                          style="font-size: 0.7em; color: var(--primary); white-space: nowrap; font-weight: normal; text-transform: none">
                          Updated {{ productData?.timeAgo }}</span>
                      </div>

                      <ng-container *ngIf="productData?.productVerficationsList?.length">
                        <ng-container
                          *ngFor="let item of showAllVerfications ? productData.productVerficationsList : [productData.productVerficationsList[0]]">
                          <!-- <ng-container *ngFor="let item of productData?.productVerficationsList"> -->
                          <div *ngIf="item != ''" class="product-verfications">
                            <div class="product-verfications__left">
                              @if (item?.isGolden) {
                              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <defs>
                                  <filter id="gold-glow" x="-50%" y="-50%" width="200%" height="200%">
                                    <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="blur" />
                                    <feOffset dx="0" dy="0" result="offsetBlur" />
                                    <feFlood flood-color="#FFD700" result="color" />
                                    <feComposite in="color" in2="offsetBlur" operator="in" result="glow" />
                                    <feMerge>
                                      <feMergeNode in="glow" />
                                      <feMergeNode in="SourceGraphic" />
                                    </feMerge>
                                  </filter>
                                </defs>

                                <!-- Star with bright gold and glow -->
                                <path
                                  d="M12 2L14.5 4L18 3.5L19 7L22 9L20.5 12L22 15L19 17L18 20.5L14.5 20L12 22L9.5 20L6 20.5L5 17L2 15L3.5 12L2 9L5 7L6 3.5L9.5 4L12 2Z"
                                  fill="#FFD700" filter="url(#gold-glow)" stroke="none" />

                                <!-- White check mark -->
                                <path d="M8.5 12L11 14.5L16 9.5" stroke="white" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                              } @else {
                              <svg viewBox="0 0 24 24" fill="none" stroke="var(--primary)" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path
                                  d="M12 2L14.5 4L18 3.5L19 7L22 9L20.5 12L22 15L19 17L18 20.5L14.5 20L12 22L9.5 20L6 20.5L5 17L2 15L3.5 12L2 9L5 7L6 3.5L9.5 4L12 2Z"
                                  fill="var(--primary)" stroke="none" />
                                <path d="M8.5 12L11 14.5L16 9.5" stroke="white" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                              }
                              <h3 class="text">{{ item.value }}</h3>
                            </div>

                            <button [class.glow-less]="item.likeCounts" [class.reaction-liked]="item.haveILiked"
                              (click)="toggleVerifyLike(item, productData)">
                              <i class="fa fa-thumbs-up"></i>
                              @if (item.likeCounts) {
                              <span class="number"><span>X</span>{{ item.likeCounts }}</span>
                              }
                            </button>
                          </div>
                        </ng-container>
                        <!-- Toggle arrow -->
                        <button *ngIf="productData?.productVerficationsList?.length > 1" class="scroll-arrow"
                          (click)="showAllVerfications = !showAllVerfications">
                          <span>
                            Show
                            {{
                            !showAllVerfications
                            ? productData?.productVerficationsList?.length -
                            1 +
                            "
                            More"
                            : "less"
                            }}</span>
                          <i [class.down]="!showAllVerfications" class="fa-solid fa-chevron-up"></i>
                        </button>
                        <!-- <div class="show-all-toggle" (click)="showAllVerfications = !showAllVerfications">
                          <span *ngIf="!showAllVerfications">▼ Show all</span>
                          <span *ngIf="showAllVerfications">▲ Show less</span>
                        </div> -->
                      </ng-container>
                      <div class="mb-1"></div>

                      <span class="title-header" *ngIf="isTherePrice(productData)">Price:</span>
                      <div class="mt-2" *ngIf="isTherePrice(productData)">
                        <!-- <div class="d-flex justify-content-between align-items-center pb-2">
                          <div>PRODUCT VARIANTS</div>
                        </div> -->

                        <textarea *ngIf="isBookNowBox" matInput formControlName="message" class="form-control mb-2 mt-2"
                          (change)="onChangeBookNowMessage($event)" rows="5" placeholder="Write Remarks..."
                          required></textarea>

                        <button *ngIf="isBookNowBox"
                          (click)="bookNow(productData, productData?.id, productData?.name, productData?.adminId, productData.seller?.first_name, productData.seller?.w_phone_number)"
                          class="btn btn-purple mb-2" [disabled]="isLoading">Send</button>

                        <div class="d-flex flex-column position-relative"
                          style="font-size: 1rem !important; color: black">
                          <ng-container *ngFor="let variants of productData?.foodSpecs; index as i">
                            <div class="w-100 d-flex w-100 justify-content-between py-2"
                              *ngIf="i < 3 || isShowingMoreVariants" style="border-bottom: 1px solid #d9d2d2">
                              <div class="w-25 mr-2" *ngIf="variants.image">
                                <img [src]="imgUrl + variants.image" style="aspect-ratio: 1/1" class="w-100 shadow-sm"
                                  *ngIf="variants.image" />
                              </div>
                              <div class="d-flex flex-column" style="width: 80%; word-break: break-all"
                                style="font-size: 0.9rem !important">
                                <span *ngIf="variants.value"> {{ variants.value }}</span>
                                <h5 *ngIf="variants.value" class="d-none">{{ variants.value }}</h5>
                                <span style="color: rgb(94, 92, 92)" *ngIf="variants.nKey && variants.nKey != '0'">{{
                                  variants.nKey }}</span>
                                <h6 *ngIf="variants.nKey && variants.nKey != '0'" class="d-none">{{ variants.nKey }}
                                </h6>
                              </div>

                              <div style="color: var(--primary); font-size: 1rem; margin-top: 0.25rem; line-height: 1.4"
                                *ngIf="variants.key && variants.key != '0'">${{ variants.key }}</div>
                            </div>
                          </ng-container>
                          <button class="scroll-arrow" (click)="isShowingMoreVariants = !isShowingMoreVariants"
                            *ngIf="productData?.foodSpecs?.length && productData?.foodSpecs?.length > 3">
                            Show {{ !isShowingMoreVariants ? productData?.foodSpecs?.length - 3 + " More" : "less" }}
                            <i [class.down]="!isShowingMoreVariants" class="fa-solid fa-chevron-up"></i>
                          </button>
                          <!-- <button class="t-btn" (click)="isShowingMoreVariants = !isShowingMoreVariants" *ngIf="productData?.foodSpecs?.length && productData?.foodSpecs?.length > 1">
                            Show {{ !isShowingMoreVariants ? productData?.foodSpecs?.length - 1 + " More" : "less" }}
                            <i [class.fa-chevron-up]="isShowingMoreVariants" [class.fa-chevron-down]="!isShowingMoreVariants" class="fa-solid fa-chevron-up"></i>
                          </button> -->
                        </div>
                        <!-- <table class="table table-sm mt-2" style="font-size: 1rem !important; color: black;     border-collapse: collapse;  "> -->
                        <!-- <thead>
                            <tr class="text-nowrap">
                              <th scope="col">Name</th>
                              <th scope="col">Details</th>
                              <th scope="col" width="15%">Price</th>
                            </tr>
                          </thead> -->
                        <!-- <tbody> -->
                        <!-- <tr >
                              <td>
                                
                               </td> -->
                        <!-- <td>{{ variants.nKey && variants.nKey != '0' ? variants.nKey : "-" }}</td> -->

                        <!-- </tr>
                          </tbody>
                        </table> -->
                      </div>

                      <div class="d-flex justify-content-between mb-1">
                        <div class="d-flex" style="gap: 5px">
                          <div *ngFor="let report of productData?.reports ?? []">
                            <span class="badge badge-danger">
                              <span *ngIf="roleService?.roles?.userType?.includes('ADMIN')" style="cursor: pointer"
                                (click)="deleteReport(report.type)">
                                <i class="fa-solid fa-times"></i>
                              </span>
                              {{ report.type }} {{ roleService?.roles?.userType?.includes("ADMIN") && report.typeCount >
                              1 ? report.typeCount : "" }}
                            </span>
                          </div>
                        </div>

                        <!--When location tab is active no need to show this so the second condiction checks that-->
                        <!-- @if ((productData?.appUser?.regionName || productData?.type == "promote") &&
                        !((productData?.type == "promote" && productData?.latLong != "{}" && productData?.latLong !=
                        null) || (productData?.type != "promote" && productData?.appUser?.postalCode != null))) {
                        <button class="btn btn-outline-primary btn-sm">
                          {{ productData?.type == "promote" ? (productData?.subRegionName == "all" ? "Doorstep" :
                          productData?.subRegionName) : productData?.appUser?.regionName }}
                        </button>
                        } -->
                      </div>
                      <span class="title-header"
                        *ngIf="!isLoading && (productData?.recommendedPins || productData?.ratings?.length || productData?.otherRatingBadges?.length)">Reviews:</span>
                      <!------------------------------------------------------->
                      <div *ngTemplateOutlet="prodReviews"></div>
                      <!--used abouve-->

                      <!-------------------------------------------------------->
                      <span class="title-header" *ngIf="productData?.description">Description:</span>
                      <div class="product-description" [class.active]="productSeeMore"
                        [innerHTML]="formattedText(productData, 'description')" #product_content></div>

                      <div class="text-center mt-1">
                        <button
                          *ngIf="productData?.type == 'promote' && productData.shoutInfo && productData.shoutInfo != 'null'"
                          class="btn btn-outline-primary btn-sm">
                          {{ productData.shoutInfo }}
                        </button>
                      </div>
                      <div class="w-100 d-flex justify-content-center position-relative">
                        <button class="scroll-arrow" (click)="productSeeMore = !productSeeMore"
                          *ngIf="canScrollDescription">
                          <span>See More</span>
                          <i [class.down]="!productSeeMore" class="fa-solid fa-chevron-up"></i>
                        </button>
                      </div>

                      <span class="title-header" *ngIf="productData?.productMoreServices?.length">Promo:</span>
                      <div class="more-services d-flex w-100 align-items-center flex-column"
                        *ngIf="productData?.productMoreServices?.length">
                        <ng-container *ngFor="let item of productData?.productMoreServices">
                          <div class="more-services__card" *ngIf="item && item.serviceComment"
                            (click)="item.imageFile ? showImage(item.imageFile, item.serviceDescription, item.serviceComment) : ''">
                            <div class="more-services__card--left">
                              <svg class="shape one" viewBox="0 0 7 18" fill="none">
                                <path
                                  d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z"
                                  fill="#CC94B2" fill-opacity="0.25" />
                              </svg>
                              <svg class="shape two" viewBox="0 0 7 18" fill="none">
                                <path
                                  d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z"
                                  fill="#EEB8A5" fill-opacity="0.25" />
                              </svg>
                              <svg class="shape three" viewBox="0 0 7 18" fill="none">
                                <path
                                  d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z"
                                  fill="#D9D9D9" fill-opacity="0.25" />
                              </svg>
                              <svg class="shape four" viewBox="0 0 7 18" fill="none">
                                <path
                                  d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z"
                                  fill="#D0CFD7" fill-opacity="0.25" />
                              </svg>
                              <svg class="shape five" viewBox="0 0 19 16" fill="none">
                                <path
                                  d="M0.274837 7.03496C7.05256 7.79001 9 0 9 0C9 0 11.5 7.9 18.5 6.5C13.5 7.5 9 15.5 9 15.5C9 15.5 8.51083 8.16245 0.274837 7.03496C0.184093 7.02485 0.0924827 7.01321 0 7C0.0925576 7.01089 0.184167 7.02255 0.274837 7.03496Z"
                                  fill="#E4719A" fill-opacity="0.25" />
                              </svg>

                              @if (item.allowRefer) {
                              <div class="more-services__card--left__price">{{ !item.referAmount || item.referAmount ==
                                "0" ? "FREE" : (item.isPercentage ? "" : "$") + item.referAmount + (item.isPercentage ?
                                "%" : "") }} {{ item.useOffText ? "OFF" : "" }}</div>
                              }
                              <div class="more-services__card--left__comment">{{ item.serviceComment }}</div>
                              <!-- @if (item.allowRefer) { @if (!profileInfo2?.linkReferedCount && !linkRfererUserId &&
                              isLogin) {
                              <button (click)="$event.stopPropagation(); showReferalUnlockExplaination()"
                                class="my-button-3 below-btn"><i class="fa-solid fa-lock"></i> Unlock</button>
                              } @else { @if (isLogin) {
                              <button (click)="$event.stopPropagation(); claimMoreService(item)"
                                class="my-button-3 below-btn">Claim</button>
                              } @else {
                              <button (click)="$event.stopPropagation(); loginHere()" class="my-button-3 below-btn"><i
                                  class="fa-solid fa-lock"></i> Login</button>
                              } } } -->
                            </div>

                            <div class="more-services__card--right">
                              <svg viewBox="0 0 53 190" fill="none">
                                <path
                                  d="M51.9999 0L-4.95911e-05 0L-4.95911e-05 189.5L26 149C30 143.5 51.4646 112.825 37.9823 107C24.5 101.175 4.09374 108.545 5.5 92.5C6.90626 76.455 54.2432 19.6542 51.9999 0Z"
                                  fill="#fff" />
                              </svg>

                              <img class="more-services__card--right__image" [src]="imgUrl + item.imageFile"
                                (error)="handleError($event)" />
                              @if (item.iconText?.trim()) {
                              <div style="position: absolute; top: 0; right: 0.5rem">
                                <app-icon-selector [nowValue]="item.iconText" [icons]="[]"
                                  [selectionEnabled]="false"></app-icon-selector>
                              </div>
                              }
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <div class="w-100 d-flex flex-wrap justify-content-center align-items-center" style="gap: 0.7em">
                        <span *ngFor="let emp of productData?.bizCompanyEmployees ?? []"
                          class="d-flex align-items-center flex-column">
                          @if (emp.image) {
                          <img [src]="imgUrl + emp.image" class="mr-2 shadow-sm"
                            style="border-radius: 50%; width: 5em; height: 5em" />
                          } @else { @if (emp.gender == "F") {
                          <img src="/../assets/images/woman.png" class="mr-2 shadow-sm"
                            style="border-radius: 50%; width: 5em; height: 5em" />
                          } @else {
                          <img src="/../assets/images/man-2.png" class="mr-2 shadow-sm"
                            style="border-radius: 50%; width: 5em; height: 5em" />
                          } }

                          <div class="d-flex flex-column justify-content-center align-items center text-center">
                            <span style="font-weight: bold">{{ emp.name }}</span>
                            <span style="color: rgb(114, 105, 105)">{{ emp.title }}</span>
                          </div>
                        </span>
                      </div>
                    </div>
                    <!-- Info -->

                    <!-- Details -->
                    <div class="mb-2" tab1>
                      <div [innerHTML]="formattedText(productData, 'charges')"></div>
                    </div>
                    <!-- Details -->
                    <!-- Price -->

                    <!-- Price -->
                    <!-- Rent -->
                    <div tab2 class="mt-4">
                      <div class="mb-3" *ngIf="productData?.depositAmt"><b>Deposit Amount : </b><i class="fa fa-usd"
                          aria-hidden="true"></i> {{ productData?.depositAmt }}</div>
                      <img *ngIf="productData?.seller?.showCardOnProducts" loading="lazy" [disabled]="isLoading"
                        (click)="buyNow(productData?.id, productData?.name, productData?.adminId, productData?.depositAmt, productData?.estimateValue)"
                        src="../../../assets/images/ccc.png" style="float: right; width: 60px; margin-top: -55px" />

                      <div class="mb-3" *ngIf="productData?.estimateValue"><b>Estimate Value : </b><i class="fa fa-usd"
                          aria-hidden="true"></i> {{ productData?.estimateValue }}</div>
                      <div class="mb-3" *ngIf="productData?.warranty"><b>Warranty Left : </b>{{ productData?.warranty }}
                        Months</div>
                    </div>
                    <!-- Rent -->
                    <!-- Shout Contact -->
                    <div tab3 class="mt-4">
                      <!-- @if(isLogin == 1){ -->
                      <div class="mb-3" *ngIf="productData?.shoutContact && productData?.shoutContact.length === 10">
                        <b>Contact Number : </b>
                        <i class="fa-brands fa-whatsapp" style="color: purple" aria-hidden="true"></i>
                        <a style="color: purple" [href]="'https://wa.me/' + productData?.shoutContact" target="_blank">
                          WhatsApp </a>
                      </div>
                      <div class="mb-3"
                        *ngIf="productData?.shoutContactRelation && productData?.shoutContactRelation != 'null'">
                        <b>Contact Relationship : </b><i class="fa fa-users" aria-hidden="true"></i> {{
                        productData?.shoutContactRelation }}</div>
                      <div class="mb-3"
                        *ngIf="productData?.shoutWebsite?.trim() && productData?.shoutWebsite != 'null'">
                        <b>Contact Website : </b> <a style="color: purple" [href]="prodSite" target="_blank">{{ prodSite
                          }}</a> <span *ngIf="productData?.isOutdated" class="text-danger ml-2">(Outdated)</span>
                      </div>
                      <!-- } -->
                    </div>
                    <!--Shout Contact -->
                    <!-- Location -->
                    <div tab4 class="mt-4 d-flex flex-column">
                      <div [class.justify-content-between]="positionString"
                        [class.justify-content-end]="!positionString" class="d-flex w-100 mb-2"
                        style="align-self: flex-start">
                        <span class="btn btn-sm btn-outline-primary" *ngIf="positionString">{{ positionString }}</span>
                        <div class="d-flex align-items-center">
                          <input type="checkbox" [(ngModel)]="productData.isPopuplarInSubRegion"
                            [id]="'pop-sub-rgn' + productData?.name" *ngIf="productData && isAdmin()"
                            (change)="currentProductTogglePopuplarInSubRegion()" />
                          <label style="margin: 0; margin-left: 0.5em" [for]="'pop-sub-rgn' + productData?.name">Popular
                            in Subregion</label>
                        </div>
                      </div>
                      <div id="map_biz" class="map mt-2" style="height: 280px"></div>
                    </div>
                    <!--Location -->
                  </app-my-tabs>
                </div>
              </div>

              <!-- <div class="col-md-4" style="border-left: 1px solid rgba(var(--black-rgb), var(--black-rgb), var(--black-rgb), 0.25)">
                <app-my-tabs [tabs]="productData?.tabs" design="3" [defaultTabIndex]="1" [slider]="true">
                  <div tab3>
                    <div class="row product_detail_promo px-2">
                      <div class="col-6 p-0" *ngFor="let row of productData?.more_products_data">
                        <div class="card mb-3 border-0 h-100" (click)="redirectToProduct(row)">
                          <div class="d-flex flex-column no-gutters">
                            <div class="container-img">
                              <img loading="lazy" src="{{ imgUrl }}{{ row?.foodImages ? row?.foodImages[0].image : row?.memberShopProductsImages[0].image }}" class="border-0 p-0 w-100" alt="..." />
                            </div>
                            <div class="pl-2 pt-1">
                              <p style="font-size: 13px; line-height: 13px" class="font-bold">
                                {{ row.name }}
                              </p>
                              <div>
                                <p class="price" style="font-size: 13px; line-height: 13px">${{ row.foodSpecs ? row.foodSpecs[0].key : row.memberShopProductsVariations[0].key }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div tab0 style="display: flex; flex-direction: column; justify-content: start; align-items: start; margin-top: 0.5rem">
                    <ng-container *ngFor="let item of productData?.productVerficationsList">
                      <div *ngIf="item != ''" class="py-1">
                        <div class="d-flex flex-row justify-content-between align-items-start">
                          <h3>
                            <div style="color: rgb(51, 1, 51); font-size: 1.1rem; font-weight: bold">
                              <span class="mr-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8A2BE2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                  <path d="M12 2L14.5 4L18 3.5L19 7L22 9L20.5 12L22 15L19 17L18 20.5L14.5 20L12 22L9.5 20L6 20.5L5 17L2 15L3.5 12L2 9L5 7L6 3.5L9.5 4L12 2Z" fill="#8A2BE2" stroke="none" />
                                  <path d="M8.5 12L11 14.5L16 9.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </span>

                              {{ item.value }}
                              <button [class.reaction-liked]="item.haveILiked" (click)="toggleVerifyLike(item)" class="ml-1 align-items-center rxn" style="background: transparent; display: inline-flex">
                                <span *ngIf="!item.likeCounts">+</span>
                                <span *ngIf="item.likeCounts" style="font-weight: bold; position: relative">
                                  <i class="fa fa-thumbs-up"></i>
                                  <span class="mr-1" *ngIf="item.likeCounts > 1" style="position: absolute; font-size: 0.7rem; top: 0px; right: -0.6rem">{{ item.likeCounts }}</span>
                                </span>
                              </button>
                            </div>
                          </h3>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div tab1 class="more-services">
                    <ng-container *ngFor="let item of productData?.productMoreServices">
                      <div *ngIf="item && item.serviceComment" class="py-1 shadow-sm p-2 w-100 mb-2" style="aspect-ratio: 0.8; position: relative; background: var(--primary); border-radius: 10px" (click)="item.imageFile ? showImage(item.imageFile, item.serviceDescription) : ''">
                        <div class="d-flex flex-column justify-content-start align-items-start" style="height: 100%">
                          <div style="color: rgb(51, 1, 51); font-size: 1.1rem; font-weight: bold; height: auto; max-width: 100%" class="d-flex align-items-center justify-content-end mb-1"></div>

                          <div class="cnt">
                            <div style="height: 70%; position: relative" class="d-flex flex-column justify-content-start">
                              <div style="max-height: calc(100% - 1.3rem); overflow: hidden">
                                <img [src]="imgUrl + item.imageFile" style="width: 100%" (error)="handleError($event)" />
                              </div>

                              <div>
                                <span>{{ item.serviceComment }}</span>
                              </div>
                              <div style="position: absolute; top: 0; right: 0">
                                @if(item.iconText?.trim()){
                                <app-icon-selector [nowValue]="item.iconText" [icons]="[]" [selectionEnabled]="false"></app-icon-selector>
                                }
                              </div>
                            </div>

                            <div class="w-100 d-flex justify-content-between">
                              <div>
                                @if(item.allowRefer){
                                <span class="ml-1 price-text">{{ !item.referAmount || item.referAmount == "0" ? "FREE" : "$" + item.referAmount }}</span>
                                }@else{
                                <div style="width: 1px"></div>
                                }
                              </div>

                              @if (item.allowRefer) { @if (!profileInfo2?.linkReferedCount && !linkRfererUserId && isLogin) {
                              <button (click)="$event.stopPropagation(); showReferalUnlockExplaination()" class="my-button-3 below-btn"><i class="fa-solid fa-lock"></i> Unlock</button>
                              } @else { @if (isLogin) {
                              <button (click)="$event.stopPropagation(); claimMoreService(item)" class="my-button-3 below-btn">Claim</button>
                              } @else {
                              <button (click)="$event.stopPropagation(); loginHere()" class="my-button-3 below-btn"><i class="fa-solid fa-lock"></i> Login</button>
                              } } }
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div tab2>
                    <div class="d-flex w-100 justify-content-center mt-3 align-items-center" style="color: var(--primary); flex-wrap: wrap">
                      <div *ngIf="productData?.seller_info?.fbUrl" class="">
                        <a [href]="correctSite(productData?.seller_info?.fbUrl)" target="_blank"> <i class="fa-brands fa-facebook-f"></i></a>
                      </div>
                      <div *ngIf="productData?.seller_info?.instagramUrl" class="mr-3 ml-3">
                        <a [href]="correctSite(productData?.seller_info?.instagramUrl)" target="_blank">
                          <i class="fa-brands fa-instagram"></i>
                        </a>
                      </div>

                      <div *ngIf="productData?.seller_info?.websiteUrl" class="d-flex mr-2">
                        <span
                          ><a [href]="correctSite(productData?.seller_info?.websiteUrl)" target="_blank" style="color: var(--primart)"> <i class="fa-solid fa-globe"></i> </a
                        ></span>
                      </div>
                    </div>
                    <ng-container *ngIf="productData?.enableMemberShop && (productData?.type != 'promote' || (productData?.type == 'promote' && (!productData?.shoutImage || !productData?.shoutName)))">
                      <popper-content #tooltipcontent>
                        <div class="popper-content">
                          <app-biz-owner-popup *ngIf="productData?.memberId" [inputId]="productData?.memberId"></app-biz-owner-popup>
                        </div>
                      </popper-content>
                      <div class="card border-0 shadow-sm h-100">
                        <div class="card-body">
                          <div class="text-center">
                            <div class="d-flex justify-content-center">
                              <i class="fa-solid fa-calendar" (click)="openHolidayPopUp(HolidayPopup)" style="position: relative; left: 7rem; color: #cc6767"></i>

                              <div style="position: absolute; left: 1.25rem">
                                <div class="d-flex flex-column">
                                  <ng-container *ngFor="let item of productData?.appUser?.appUserCertificates; let i = index">
                                    <img loading="lazy" src="{{ imgUrl }}public/images/certificate/{{ item.role }}.png" style="height: 1.5rem; width: 1.5rem; border-radius: 50%" />
                                  </ng-container>
                                </div>
                              </div>
                              <div>
                                <img loading="lazy" (click)="goToProfileDetail()" [popper]="tooltipcontent" [popperTrigger]="screenWidth > 767 ? 'hover' : 'click'" [popperPlacement]="'right'" src="{{ local.checkImageProfile(productData?.appUser) }}" class="shadow-sm rounded-circle border char-image" style="width: 85px; height: 85px; cursor: pointer" />
                              </div>
                            </div>

                            <h6 class="mb-0 pt-2 text-center text-name" (click)="goToProfileDetail()">
                              {{ productData?.appUser?.profileCharacterName || "Anonymous" }}
                            </h6>
                            <div class="d-flex flex-column">
                              <small>Level {{ productData?.appUser?.level || "0" }} ({{ productData?.appUser?.supporters }} supporters)</small>
                            </div>
                          </div>
                          <div class="text-left mt-1">
                            <p style="line-height: 14px; font-size: 16px; text-transform: none">
                              {{ productData?.appUser?.shortDescription || "" }}
                            </p>

                            <div class="d-flex flex-wrap mt-3" style="gap: 2px">
                              <span *ngIf="productData?.appUser?.regionName">
                                <div class="badge-purple">{{ productData?.appUser?.regionName }}</div>
                              </span>
                              <ng-container *ngIf="productData?.appUser && isArray(productData?.appUser?.certified)">
                                <span class="badge-purple" *ngFor="let item of productData?.appUser?.certified">
                                  {{ item }}
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!productData?.enableMemberShop && productData?.seller?.shop_logo">
                      <div class="profile-info">
                        <div class="profile-info__image">
                          <img loading="lazy" (click)="openBizLink()" style="cursor: pointer" src="{{ !productData?.seller?.shop_logo ? '../../../assets/images/new/badge.png' : imgUrl + productData?.seller?.shop_logo }}" />
                        </div>
                        <div class="profile-info__name" (click)="openBizLink()" *ngIf="isLogin">
                          {{ productData?.seller?.shop_name ?? "-" }}
                        </div>
                        <div class="profile-info__desc" [innerHTML]="productData?.seller?.shop_description ?? ''"></div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="productData?.type == 'promote' && productData?.shoutImage && productData?.shoutName">
                      <div class="profile-info">
                        <div class="profile-info__image">
                          <img loading="lazy" (click)="openBizLink(true)" style="cursor: pointer" [src]="imgUrl + productData?.shoutImage" />
                        </div>
                        <div class="profile-info__name" (click)="openBizLink(true)">
                          {{ productData?.shoutName && productData?.shoutName != "null" ? productData?.shoutName : "" }}
                        </div>
                        <div class="profile-info__desc" [innerHTML]="productData?.shoutDescription && productData?.shoutDescription != 'null' ? productData?.shoutDescription : ''"></div>
                      </div>
                    </ng-container>
                    <div class="mt-2">
                      <div class="d-flex w-100" *ngIf="screenWidth > 767 && productData?.enableMemberShop">
                        <div ngbDropdown placement="bottom-end" *ngIf="productData?.type !== 'promote' || (productData?.shoutContactRelation | nullCheck)" [style.background-color]="productData?.type !== 'promote' || (productData?.shoutContactRelation | nullCheck) ? 'var(--primary)' : 'inherit'" class="w-100">
                          <span class="w-100 d-flex justify-content-center text-white small" *ngIf="productData?.type == 'promote' && (productData?.shoutContactRelation | nullCheck)" style="margin-top: 6px">{{ productData?.shoutContactRelation | nullCheck }}</span>
                          <button style="background-color: var(--primary)" *ngIf="productData?.type != 'promote'" class="btn btn-sm btn-primary w-100 mr-2" [disabled]="productData?.seller?.isDisabled || isUserDisabled" ngbDropdownToggle><i class="fa-solid fa-comments"></i> {{ !productData?.seller?.isDisabled && !isUserDisabled ? "Chat Now" : "Not Available" }}</button>

                          <div ngbDropdownMenu class="w-100 p-0" *ngIf="isLogin && !productData?.seller?.isDisabled && !isUserDisabled && (!productData?.shoutContact || productData?.shoutContact == '65null')">
                            <button *ngIf="showChatNow" ngbDropdownItem (click)="handleChatNow()"><i class="fa-solid fa-comment-dots"></i> Chat Now</button>
                            <button *ngIf="!productData?.isOwner && !productData?.isBooked && productData?.seller?.turnOffWhatsapp === 1" ngbDropdownItem (click)="openBookNowBox()"><i class="fa-solid fa-comment-dots"></i> Book Now ({{ remainingClickBook() }})</button>
                            <button *ngIf="productData?.isOwner" ngbDropdownItem><i class="fa-brands fa-whatsapp"></i> {{ productData.remainingBookTimes }} Bookings Left</button>
                            <button *ngIf="(productData?.isBooked || productData?.seller?.buyerContact === 0) && productData?.seller?.w_phone_number" ngbDropdownItem (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
                            <button ngbDropdownItem (click)="handleTelegram(productData.id)" *ngIf="productData?.roleName?.includes('SUPER SELLER') && productData?.seller?.allowBookDriver"><i class="fa-brands fa-telegram"></i> Book Driver</button>
                            <button ngbDropdownItem *ngIf="showTelegramButton" (click)="openTelegramAccount(productData?.seller?.w_phone_number)"><i class="fa-brands fa-telegram"></i> Telegram</button>
                          </div>
                        </div>
                        <div ngbDropdown placement="bottom-end" *ngIf="productData?.type == 'promote' && productData?.shoutContact && !(productData?.shoutContactRelation | nullCheck)" [style.background-color]="productData?.type == 'promote' && productData?.shoutContact ? 'var(--primary)' : 'inherit'" class="w-100">
                          <button style="background-color: var(--primary)" *ngIf="productData?.shoutContact" class="btn btn-sm btn-primary w-100 mr-2" [disabled]="productData?.seller?.isDisabled || isUserDisabled" ngbDropdownToggle><i class="fa-solid fa-comments"></i> {{ !productData?.seller?.isDisabled && !isUserDisabled ? "Chat Now" : "Not Available" }}</button>

                          <div ngbDropdownMenu class="w-100 p-0" *ngIf="isLogin && !productData?.seller?.isDisabled && !isUserDisabled">
                            <button *ngIf="productData?.shoutContact" ngbDropdownItem (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
                          </div>
                        </div>
                        <div class="dropdown-product ml-auto" *ngIf="isLogin == 1">
                          <div class="my-btn-list" *ngIf="roleService.roles?.level?.includes('MEMBER_VERIFIED_USER')" (click)="productData.showDropdown = !productData.showDropdown">
                            <i class="fa-solid fa-ellipsis-v text-dark"></i>
                          </div>
                          <div *ngIf="productData?.showDropdown" class="dropdown-product-detail bg-white" (mouseleave)="productData.showDropdown = false">
                            <div class="dropdown-product-detail__item" (click)="openReportModal(reportsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-flag"></i> Report</div>
                            <div class="dropdown-product-detail__item suggest-shepherd" (click)="openSuggestModal(suggestionsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-lightbulb pr-1"></i> Suggest</div>
                            <div class="dropdown-product-detail__item" (click)="handleHideProduct()" *ngIf="productData?.showDropdown && productData?.enableMemberShop"><i class="fa-regular fa-eye-slash"></i> Hide({{ productData?.hiddenBy?.length }})</div>
                            <ng-container *ngIf="productData?.enableMemberShop && roleService?.roles?.users?.includes('MEMBER_SHOP_PRODUCT')">
                              <div class="dropdown-product-detail__item" (click)="editMemberProduct()" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('EDIT')"><i class="fa fa-pencil"></i> Edit</div>
                              <div class="dropdown-product-detail__item" (click)="deleteMemberProduct(productData?.id)" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('DELETE')"><i class="fa fa-trash"></i> Delete</div>

                              <div class="dropdown-product-detail__item" (click)="attachMemberProduct(AttachMemberProduct, productData?.id)" *ngIf="roleService.roles?.users?.includes('ATTACH_PRODUCT')"><i class="fa fa-paperclip"></i> Attach</div>
                              <div class="dropdown-product-detail__item" (click)="deleteProductsAttachment()" *ngIf="roleService?.roles?.users?.includes('ATTACH_PRODUCT') && productData && productData?.attachmentProductsKey"><i class="fa fa-trash"></i> Delete Attach</div>
                              <div class="dropdown-product-detail__item" (click)="shareContent()"><i class="fa fa-share-alt"></i> Share Service</div>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <small class="text-danger" *ngIf="productData?.errorChatURL">Contact Seller Via Other Methods</small>
                    </div>
                  </div>
                  <div tab4>
                    <div class="socials">
                      <b class="mt-4" *ngIf="productData?.sellerInformation?.googleReviewUrl || productData?.sellerInformation?.carousellReviewUrl || productData?.sellerInformation?.fbReviewUrl">Reviews</b>
                      <section *ngIf="productData?.sellerInformation?.googleReviewUrl || productData?.sellerInformation?.googleReviewRating || productData?.sellerInformation?.googleReviewCount">
                        <a [href]="'http://' + sellerInformation?.googleReviewUrl" target="_blank">
                          {{
                            (productData?.sellerInformation?.googleReviewRating + " Star" || "") +
                              " Google
                          " +
                              (productData?.sellerInformation?.googleReviewCount ? "(" + productData?.sellerInformation?.googleReviewCount + ")" : "")
                          }}
                        </a>
                      </section>
                      <section *ngIf="productData?.sellerInformation?.carousellReviewUrl || productData?.sellerInformation?.carousellReviewRating || productData?.sellerInformation?.carousellReviewCount">
                        <a [href]="'http://' + sellerInformation?.carousellReviewUrl" target="_blank">
                          {{
                            (productData?.sellerInformation?.carousellReviewRating + " Star" || "") +
                              "Carousell
                          " +
                              (sellerInformation?.carousellReviewCount ? "(" + productData?.sellerInformation?.carousellReviewCount + ")" : "")
                          }}
                        </a>
                      </section>
                      <section *ngIf="productData?.sellerInformation?.fbReviewUrl || productData?.sellerInformation?.fbReviewRating || productData?.sellerInformation?.fbReviewCount">
                        <a [href]="'http://' + sellerInformation?.fbReviewUrl" target="_blank">
                          {{
                            (productData?.sellerInformation?.fbReviewRating + " Star" || "") +
                              "
                          Facebook " +
                              (productData?.sellerInformation?.fbReviewCount ? "(" + productData?.sellerInformation?.fbReviewCount + ")" : "")
                          }}
                        </a>
                      </section>
                      <ng-container *ngIf="productData?.sellerInformation?.websiteUrl || productData?.sellerInformation?.instagramUrl || productData?.sellerInformation?.fbUrl">
                        <br />
                        @if (productData?.sellerInformation?.websiteUrl || productData?.sellerInformation?.instagramUrl || productData?.sellerInformation?.fbUrl) {
                        <b>Socials</b>
                        }
                        <ng-container *ngIf="productData?.sellerInformation?.websiteUrl"><br /><a [href]="'http://' + productData?.sellerInformation?.websiteUrl" target="_blank">Website</a></ng-container>
                        <ng-container *ngIf="productData?.sellerInformation?.instagramUrl"> <br /><a [href]="'http://' + productData?.sellerInformation?.instagramUrl" target="_blank">Instagram</a></ng-container>
                        <ng-container *ngIf="productData?.sellerInformation?.fbUrl"><br /><a *ngIf="productData?.sellerInformation?.fbUrl" [href]="'http://' + productData?.sellerInformation?.fbUrl" target="_blank">Facebook</a></ng-container>
                        <br />
                      </ng-container>
                      <ng-container *ngIf="!productData?.enableMemberShop">
                        <b class="mt-4"> Seller Info </b>
                        <br />{{ productData?.sellerInformation?.sellerInfo || defaultSellerMsg }}
                      </ng-container>
                    </div>
                  </div>
                  <div tab3>
                  <ngb-datepicker
                    #dp
                    [minDate]="{
                      year: today.getFullYear(),
                      month: today.getMonth() + 1,
                      day: today.getDate() + 1
                    }"
                    [dayTemplate]="datePicker"
                    outsideDays="hidden"
                  >
                  </ngb-datepicker>
                  <ng-template #datePicker let-date="date" let-focused="focused">
                    <div class="custom-day" [class.focused]="focused" [class.selected]="isSelected(date)">
                      {{ date.day }}
                    </div>
                  </ng-template>
                </div>
                </app-my-tabs>
              </div> -->
            </div>

            <div class="add_cart mt-4 mb-4">
              <a class="go_to_cart_btn"
                *ngIf="productData?.roleName?.includes('SUPER SELLER') && productData?.referralLink"
                (click)="openMemberLinkPopup($event, memberLinkPopup, productData?.edit_product_id, 'referral')">
                Referral Link </a>
              <a class="add_to_cart_btn mt-2"
                *ngIf="productData?.roleName?.includes('SUPER SELLER') && productData?.storeLink"
                (click)="openMemberLinkPopup($event, memberLinkPopup, productData?.edit_product_id, 'store')"> Store
                Link </a>
            </div>

            <!-- suggestions -->
            <div class="tabs-suggestions position-relative">
              <div class="position-absolute" style="left: 100%">
                <button class="t-btn" (click)="isAddPromoVisible = !isAddPromoVisible">
                  <i class="fa fa-ellipsis-v"></i>
                  <div class="position-absolute" style="bottom: 100%; right: 100%" *ngIf="isAddPromoVisible">
                    <button class="p-2 rounded"
                      style="background-color: var(--white); border: 1px solid var(--secondary); width: 10em; color: var(--secondary)"
                      (click)="$event.stopPropagation(); openAdInProductModal(productData)"
                      (clickOutside)="isAddPromoVisible = false"><i class="fa fa-star"></i> Add Promo In This
                      Product</button>
                  </div>
                </button>
              </div>

              <app-my-tabs [tabs]="productData?.tabsRecommend" *ngIf="productData?.tabsRecommend?.length" design="5">
                <div tab0>
                  <app-marketplace-recommendation (addClick)="showLoginError('review')" *ngIf="productData"
                    [productData]="productData"
                    (changeRecommend)="handleChangeRecommend(productData, $event)"></app-marketplace-recommendation>
                </div>
                <div tab1 class="more-services">
                  <!--Removed will not work but might return so code is here but removed by condition: falase on tabsRecommend object-->
                  <ng-container *ngFor="let item of productData?.productMoreServices">
                    <div class="more-services__card" *ngIf="item && item.serviceComment"
                      (click)="item.imageFile ? showImage(item.imageFile, item.serviceDescription) : ''">
                      <div class="more-services__card--left">
                        <svg class="shape one" viewBox="0 0 7 18" fill="none">
                          <path
                            d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z"
                            fill="#CC94B2" fill-opacity="0.25" />
                        </svg>
                        <svg class="shape two" viewBox="0 0 7 18" fill="none">
                          <path
                            d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z"
                            fill="#EEB8A5" fill-opacity="0.25" />
                        </svg>
                        <svg class="shape three" viewBox="0 0 7 18" fill="none">
                          <path
                            d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z"
                            fill="#D9D9D9" fill-opacity="0.25" />
                        </svg>
                        <svg class="shape four" viewBox="0 0 7 18" fill="none">
                          <path
                            d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z"
                            fill="#D0CFD7" fill-opacity="0.25" />
                        </svg>
                        <svg class="shape five" viewBox="0 0 19 16" fill="none">
                          <path
                            d="M0.274837 7.03496C7.05256 7.79001 9 0 9 0C9 0 11.5 7.9 18.5 6.5C13.5 7.5 9 15.5 9 15.5C9 15.5 8.51083 8.16245 0.274837 7.03496C0.184093 7.02485 0.0924827 7.01321 0 7C0.0925576 7.01089 0.184167 7.02255 0.274837 7.03496Z"
                            fill="#E4719A" fill-opacity="0.25" />
                        </svg>

                        @if (item.allowRefer) {
                        <div class="more-services__card--left__price">
                          {{ !item.referAmount || item.referAmount == "0" ? "FREE" : "$" + item.referAmount }}
                        </div>
                        }
                        <div class="more-services__card--left__comment">{{ item.serviceComment }}</div>
                        @if (item.allowRefer) { @if (!profileInfo2?.linkReferedCount && !linkRfererUserId && isLogin) {
                        <button (click)="$event.stopPropagation(); showReferalUnlockExplaination()"
                          class="my-button-3 below-btn"><i class="fa-solid fa-lock"></i> Unlock</button>
                        } @else { @if (isLogin) {
                        <button (click)="$event.stopPropagation(); claimMoreService(item)"
                          class="my-button-3 below-btn">Claim</button>
                        } @else {
                        <button (click)="$event.stopPropagation(); loginHere()" class="my-button-3 below-btn"><i
                            class="fa-solid fa-lock"></i> Login</button>
                        } } }
                      </div>

                      <div class="more-services__card--right">
                        <svg viewBox="0 0 53 190" fill="none">
                          <path
                            d="M51.9999 0L-4.95911e-05 0L-4.95911e-05 189.5L26 149C30 143.5 51.4646 112.825 37.9823 107C24.5 101.175 4.09374 108.545 5.5 92.5C6.90626 76.455 54.2432 19.6542 51.9999 0Z"
                            fill="#fff" />
                        </svg>

                        <img class="more-services__card--right__image" [src]="imgUrl + item.imageFile"
                          (error)="handleError($event)" />
                        @if (item.iconText?.trim()) {
                        <div style="position: absolute; top: 0; right: 0.5rem">
                          <app-icon-selector [nowValue]="item.iconText" [icons]="[]"
                            [selectionEnabled]="false"></app-icon-selector>
                        </div>
                        }
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div tab2>
                  <div style="max-width: 20rem; margin: auto">
                    <div class="d-flex w-100 justify-content-center mt-3 align-items-center"
                      style="color: var(--primary); flex-wrap: wrap">
                      <div *ngIf="productData?.seller_info?.fbUrl" class="mr-3">
                        <a [href]="correctSite(productData?.seller_info?.fbUrl)" target="_blank"> <i
                            class="fa-brands fa-facebook-f"></i></a>
                      </div>
                      <div *ngIf="productData?.seller_info?.instagramUrl" class="mr-3">
                        <a [href]="correctSite(productData?.seller_info?.instagramUrl)" target="_blank">
                          <i class="fa-brands fa-instagram"></i>
                        </a>
                      </div>

                      <div *ngIf="productData?.seller_info?.websiteUrl" class="d-flex mr-2">
                        <span><a [href]="correctSite(productData?.seller_info?.websiteUrl)" target="_blank"
                            style="color: var(--primart)"> <i class="fa-solid fa-globe"></i> </a></span>
                      </div>
                    </div>
                    <ng-container
                      *ngIf="productData?.type != 'promote' || (productData?.type == 'promote' && (!productData?.shoutImage || !productData?.shoutName))">
                      <!-- Hover User Info  -->
                      <popper-content #tooltipcontent>
                        <div class="popper-content">
                          <app-biz-owner-popup *ngIf="productData?.memberId"
                            [inputId]="productData?.memberId"></app-biz-owner-popup>
                        </div>
                      </popper-content>
                      <!-- Hover User Info  -->
                      <div class="card border-0 shadow-sm h-100">
                        <div class="card-body">
                          <div class="text-center">
                            <div class="d-flex justify-content-center">
                              <i class="fa-solid fa-calendar" (click)="openHolidayPopUp(HolidayPopup)"
                                style="position: relative; left: 7rem; color: #cc6767"></i>

                              <div style="position: absolute; left: 1.25rem">
                                <div class="d-flex flex-column">
                                  <ng-container
                                    *ngFor="let item of productData?.appUser?.appUserCertificates; let i = index">
                                    <img loading="lazy" src="{{ imgUrl }}public/images/certificate/{{ item.role }}.png"
                                      style="height: 1.5rem; width: 1.5rem; border-radius: 50%" />
                                  </ng-container>
                                </div>
                              </div>
                              <div>
                                <img loading="lazy" (click)="goToProfileDetail()" [popper]="tooltipcontent"
                                  [popperTrigger]="screenWidth > 767 ? 'hover' : 'click'" [popperPlacement]="'right'"
                                  src="{{ local.checkImageProfile(productData?.appUser) }}"
                                  class="shadow-sm rounded-circle border char-image"
                                  style="width: 85px; height: 85px; cursor: pointer" />
                              </div>
                            </div>

                            <h6
                              class="mb-0 pt-2 text-center text-name d-flex justify-content-center align-items-center">
                              <span class="mr-1" (click)="goToProfileDetail()">{{
                                productData?.appUser?.profileCharacterName || "Anonymous" }}</span>
                              <div class="dropdown-product" *ngIf="isLogin == 1 && screenWidth <= 767"
                                (click)="$event.stopPropagation()">
                                <div class="my-btn-list"
                                  *ngIf="roleService.roles?.userType?.includes('ADMIN') || productData?.memberId == profileInfo2?.id"
                                  (click)="productData.showDropdown = !productData.showDropdown">
                                  <i class="fa-solid fa-ellipsis-v text-dark"></i>
                                </div>
                                <!-- <div *ngIf="productData?.showDropdown" class="dropdown-product-detail bg-white" (mouseleave)="productData.showDropdown = false">
                                  <div class="dropdown-product-detail__item" (click)="openReportModal(reportsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-flag"></i> Report</div>
                                  <div class="dropdown-product-detail__item suggest-shepherd" (click)="openSuggestModal(suggestionsPopup)" *ngIf="productData?.showDropdown"><i class="fa-regular fa-lightbulb pr-1"></i> Suggest</div>
                                  <div class="dropdown-product-detail__item" (click)="handleHideProduct()" *ngIf="productData?.showDropdown && mainProductEnableMemberShop"><i class="fa-regular fa-eye-slash"></i> Hide({{ productData?.hiddenBy?.length }})</div>
                                  <ng-container *ngIf="mainProductEnableMemberShop && roleService?.roles?.users?.includes('MEMBER_SHOP_PRODUCT')">
                                    <div class="dropdown-product-detail__item" (click)="editMemberProduct()" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('EDIT')"><i class="fa fa-pencil"></i> Edit</div>
                                    <div class="dropdown-product-detail__item" (click)="deleteMemberProduct(productData?.id)" *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('DELETE')"><i class="fa fa-trash"></i> Delete</div>
      
                                    <div class="dropdown-product-detail__item" (click)="attachMemberProduct(AttachMemberProduct, productData?.id)" *ngIf="roleService.roles?.users?.includes('ATTACH_PRODUCT')"><i class="fa fa-paperclip"></i> Attach</div>
                                    <div class="dropdown-product-detail__item" (click)="deleteProductsAttachment()" *ngIf="roleService?.roles?.users?.includes('ATTACH_PRODUCT') && productData && productData?.attachmentProductsKey"><i class="fa fa-trash"></i> Delete Attach</div>
                                    <div class="dropdown-product-detail__item" (click)="shareContent()"><i class="fa fa-share-alt"></i> Share Service</div>
                                  </ng-container>
                                </div> -->
                              </div>
                            </h6>
                            <div class="d-flex flex-column">
                              <!-- <small *ngIf="productData?.appUser?.regionName" class="text-primary">{{
                              productData?.appUser?.regionName }}</small> -->
                              <small>Level {{ productData?.appUser?.level || "0" }} ({{ productData?.appUser?.supporters
                                }} supporters) <span class="badge-pink" style="cursor: pointer"
                                  (click)="handleSupportSeller()">+ Friend</span></small>
                            </div>
                          </div>
                          <div class="text-left mt-1">
                            <p style="line-height: 14px; font-size: 16px; text-transform: none"
                              *ngIf="productData?.appUser?.shortDescription != 'null'">
                              {{ productData?.appUser?.shortDescription || "" }}
                            </p>

                            <div class="d-flex flex-wrap mt-3" style="gap: 2px">
                              <span *ngIf="productData?.appUser?.regionName">
                                <div class="badge-purple">{{ productData?.appUser?.regionName }}</div>
                              </span>
                              <ng-container *ngIf="productData?.appUser && isArray(productData?.appUser?.certified)">
                                <span class="badge-purple" *ngFor="let item of productData?.appUser?.certified">
                                  {{ item }}
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!productData?.mainProductEnableMemberShop && productData?.seller?.shop_logo">
                      <div class="profile-info">
                        <div class="profile-info__image">
                          <img loading="lazy" (click)="openBizLink()" style="cursor: pointer"
                            src="{{ !productData?.seller?.shop_logo ? '../../../assets/images/new/badge.png' : imgUrl + productData?.seller?.shop_logo }}" />
                        </div>
                        <div class="profile-info__name" (click)="openBizLink()" *ngIf="isLogin">
                          {{ productData?.seller?.shop_name ?? "-" }}
                        </div>
                        <div class="profile-info__desc" [innerHTML]="productData?.seller?.shop_description ?? ''"></div>
                      </div>
                    </ng-container>
                    <ng-container
                      *ngIf="productData?.type == 'promote' && productData?.shoutImage && productData?.shoutName">
                      <div class="profile-info">
                        <div class="profile-info__image">
                          <img loading="lazy" (click)="openBizLink(true)" style="cursor: pointer"
                            [src]="imgUrl + productData?.shoutImage" />
                        </div>
                        <div class="profile-info__name" (click)="openBizLink(true)">
                          {{ productData?.shoutName && productData?.shoutName != "null" ? productData?.shoutName : "" }}
                        </div>
                        <div class="profile-info__desc"
                          [innerHTML]="productData?.shoutDescription && productData?.shoutDescription != 'null' ? productData?.shoutDescription : ''">
                        </div>
                      </div>
                    </ng-container>
                    <div class="mt-2">
                      <div class="d-flex w-100" *ngIf="screenWidth > 767 && mainProductEnableMemberShop">
                        <div ngbDropdown placement="bottom-end"
                          *ngIf="productData?.type !== 'promote' || (productData?.shoutContactRelation | nullCheck)"
                          [style.background-color]="productData?.type !== 'promote' || (productData?.shoutContactRelation | nullCheck) ? 'var(--primary)' : 'inherit'"
                          class="w-100">
                          <span class="w-100 d-flex justify-content-center text-white small"
                            *ngIf="productData?.type == 'promote' && (productData?.shoutContactRelation | nullCheck)"
                            style="margin-top: 6px">{{ productData?.shoutContactRelation | nullCheck }}</span>
                          <button style="background-color: var(--primary)" *ngIf="productData?.type != 'promote'"
                            class="btn btn-sm btn-primary w-100 mr-2"
                            [disabled]="productData?.seller?.isDisabled || isUserDisabled" ngbDropdownToggle><i
                              class="fa-solid fa-comments"></i> {{ !productData?.seller?.isDisabled && !isUserDisabled ?
                            "Chat Now" : "Not Available" }}</button>

                          <div ngbDropdownMenu class="w-100 p-0"
                            *ngIf="isLogin && !productData?.seller?.isDisabled && !isUserDisabled && (!productData?.shoutContact || productData?.shoutContact == '65null')">
                            <button *ngIf="showChatNow" ngbDropdownItem (click)="handleChatNow()"><i
                                class="fa-solid fa-comment-dots"></i> Chat Now</button>
                            <button
                              *ngIf="!productData?.isOwner && !productData?.isBooked && productData?.seller?.turnOffWhatsapp === 1"
                              ngbDropdownItem (click)="openBookNowBox()"><i class="fa-solid fa-comment-dots"></i> Book
                              Now ({{ remainingClickBook() }})</button>
                            <button *ngIf="productData?.isOwner" ngbDropdownItem><i class="fa-brands fa-whatsapp"></i>
                              {{ productData.remainingBookTimes }} Bookings Left</button>
                            <button
                              *ngIf="(productData?.isBooked || productData?.seller?.buyerContact === 0) && productData?.seller?.w_phone_number"
                              ngbDropdownItem (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp
                              ({{ remainingClickBook(1) }})</button>
                            <button ngbDropdownItem (click)="handleTelegram(productData.id)"
                              *ngIf="productData?.roleName?.includes('SUPER SELLER') && productData?.seller?.allowBookDriver"><i
                                class="fa-brands fa-telegram"></i> Book Driver</button>
                            <button ngbDropdownItem *ngIf="showTelegramButton"
                              (click)="openTelegramAccount(productData?.seller?.w_phone_number)"><i
                                class="fa-brands fa-telegram"></i> Telegram</button>
                          </div>
                        </div>
                        <div ngbDropdown placement="bottom-end"
                          *ngIf="productData?.type == 'promote' && productData?.shoutContact && !(productData?.shoutContactRelation | nullCheck)"
                          [style.background-color]="productData?.type == 'promote' && productData?.shoutContact ? 'var(--primary)' : 'inherit'"
                          class="w-100">
                          <button style="background-color: var(--primary)" *ngIf="productData?.shoutContact"
                            class="btn btn-sm btn-primary w-100 mr-2"
                            [disabled]="productData?.seller?.isDisabled || isUserDisabled" ngbDropdownToggle><i
                              class="fa-solid fa-comments"></i> {{ !productData?.seller?.isDisabled && !isUserDisabled ?
                            "Chat Now" : "Not Available" }}</button>

                          <div ngbDropdownMenu class="w-100 p-0"
                            *ngIf="isLogin && !productData?.seller?.isDisabled && !isUserDisabled">
                            <button *ngIf="productData?.shoutContact" ngbDropdownItem (click)="redirectLink()"><i
                                class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
                          </div>
                        </div>

                        <div class="dropdown-product ml-auto" *ngIf="isLogin == 1">
                          <div class="my-btn-list"
                            *ngIf="roleService.roles?.userType?.includes('ADMIN') || productData?.memberId == profileInfo2?.id"
                            (click)="productData.showDropdown = !productData.showDropdown">
                            <i class="fa-solid fa-ellipsis-v text-dark"></i>
                          </div>
                          <div *ngIf="productData?.showDropdown" class="dropdown-product-detail bg-white"
                            (mouseleave)="productData.showDropdown = false">
                            <div class="dropdown-product-detail__item" (click)="openReportModal(reportsPopup)"
                              *ngIf="productData?.showDropdown"><i class="fa-regular fa-flag"></i> Report</div>
                            <div class="dropdown-product-detail__item suggest-shepherd"
                              (click)="openSuggestModal(suggestionsPopup)" *ngIf="productData?.showDropdown"><i
                                class="fa-regular fa-lightbulb pr-1"></i> Suggest</div>
                            <div class="dropdown-product-detail__item" (click)="handleHideProduct()"
                              *ngIf="productData?.showDropdown && mainProductEnableMemberShop"><i
                                class="fa-regular fa-eye-slash"></i> Hide({{ productData?.hiddenBy?.length }})</div>
                            <ng-container
                              *ngIf="mainProductEnableMemberShop && roleService?.roles?.users?.includes('MEMBER_SHOP_PRODUCT')">
                              <div class="dropdown-product-detail__item" (click)="editMemberProduct()"
                                *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('EDIT')"><i
                                  class="fa fa-pencil"></i> Edit</div>
                              <div class="dropdown-product-detail__item" (click)="deleteMemberProduct(productData?.id)"
                                *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('DELETE')"><i
                                  class="fa fa-trash"></i> Delete</div>

                              <div class="dropdown-product-detail__item"
                                (click)="attachMemberProduct(AttachMemberProduct, productData?.id)"
                                *ngIf="roleService.roles?.users?.includes('ATTACH_PRODUCT')"><i
                                  class="fa fa-paperclip"></i> Attach</div>
                              <div class="dropdown-product-detail__item" (click)="deleteProductsAttachment()"
                                *ngIf="roleService?.roles?.users?.includes('ATTACH_PRODUCT') && productData && productData?.attachmentProductsKey">
                                <i class="fa fa-trash"></i> Delete Attach</div>
                              <div class="dropdown-product-detail__item" (click)="shareContent()"><i
                                  class="fa fa-share-alt"></i> Share Service</div>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <small class="text-danger" *ngIf="productData?.errorChatURL">Contact Seller Via Other
                        Methods</small>
                    </div>
                    <!-- <div class="d-flex justify-content-center" style="gap: 0.5em; margin: 0.5rem 0; padding-top: 0.5rem; border-top: 1px solid rgba(var(--black-rgb), var(--black-rgb), var(--black-rgb), 0.15)">
                      <button class="btn btn-outline-primary" style="font-size: 0.9em">Quick replies</button>
                      <button class="btn btn-outline-primary" style="font-size: 0.9em">Worth the cost</button>
                      <button class="btn btn-outline-primary" style="font-size: 0.9em">Certified or experienced</button>
                    </div> -->
                  </div>
                </div>
                <div tab3>
                  <app-marketplace-forum *ngIf="mainProductEnableMemberShop && productData?.forum"
                    [productForum]="productData?.forum" [hideNonEssential]="true"></app-marketplace-forum>
                </div>
                <div tab4>
                  <div class="row product_detail_promo px-2">
                    <div class="col-6 p-0" *ngFor="let row of productData?.more_products_data">
                      <div class="card mb-3 border-0 h-100" (click)="redirectToProduct(row)">
                        <div class="d-flex flex-column no-gutters">
                          <div class="container-img">
                            <img loading="lazy"
                              src="{{ imgUrl }}{{ row?.foodImages ? row?.foodImages[0].image : row?.memberShopProductsImages[0].image }}"
                              class="border-0 p-0 w-100" alt="..." />
                          </div>
                          <div class="pl-2 pt-1">
                            <p style="font-size: 13px; line-height: 13px" class="font-bold">
                              {{ row.name }}
                            </p>
                            <div>
                              <p class="price" style="font-size: 13px; line-height: 13px">${{ row.foodSpecs ?
                                row.foodSpecs[0].key : row.memberShopProductsVariations[0].key }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div tab5>
                  <div class="socials">
                    <b class="mt-4"
                      *ngIf="productData?.sellerInformation?.googleReviewUrl || productData?.sellerInformation?.carousellReviewUrl || productData?.sellerInformation?.fbReviewUrl">Reviews</b>
                    <section
                      *ngIf="productData?.sellerInformation?.googleReviewUrl || productData?.sellerInformation?.googleReviewRating || productData?.sellerInformation?.googleReviewCount">
                      <a [href]="'http://' + sellerInformation?.googleReviewUrl" target="_blank">
                        {{
                        (productData?.sellerInformation?.googleReviewRating + " Star" || "") +
                        " Google
                        " +
                        (productData?.sellerInformation?.googleReviewCount ? "(" +
                        productData?.sellerInformation?.googleReviewCount + ")" : "")
                        }}
                      </a>
                    </section>
                    <section
                      *ngIf="productData?.sellerInformation?.carousellReviewUrl || productData?.sellerInformation?.carousellReviewRating || productData?.sellerInformation?.carousellReviewCount">
                      <a [href]="'http://' + sellerInformation?.carousellReviewUrl" target="_blank">
                        {{
                        (productData?.sellerInformation?.carousellReviewRating + " Star" || "") +
                        "Carousell
                        " +
                        (sellerInformation?.carousellReviewCount ? "(" +
                        productData?.sellerInformation?.carousellReviewCount + ")" : "")
                        }}
                      </a>
                    </section>
                    <section
                      *ngIf="productData?.sellerInformation?.fbReviewUrl || productData?.sellerInformation?.fbReviewRating || productData?.sellerInformation?.fbReviewCount">
                      <a [href]="'http://' + sellerInformation?.fbReviewUrl" target="_blank">
                        {{
                        (productData?.sellerInformation?.fbReviewRating + " Star" || "") +
                        "
                        Facebook " +
                        (productData?.sellerInformation?.fbReviewCount ? "(" +
                        productData?.sellerInformation?.fbReviewCount + ")" : "")
                        }}
                      </a>
                    </section>
                    <ng-container
                      *ngIf="productData?.sellerInformation?.websiteUrl || productData?.sellerInformation?.instagramUrl || productData?.sellerInformation?.fbUrl">
                      <br />
                      @if (productData?.sellerInformation?.websiteUrl || productData?.sellerInformation?.instagramUrl ||
                      productData?.sellerInformation?.fbUrl) {
                      <b>Socials</b>
                      }
                      <ng-container *ngIf="productData?.sellerInformation?.websiteUrl"><br /><a
                          [href]="'http://' + productData?.sellerInformation?.websiteUrl"
                          target="_blank">Website</a></ng-container>
                      <ng-container *ngIf="productData?.sellerInformation?.instagramUrl"> <br /><a
                          [href]="'http://' + productData?.sellerInformation?.instagramUrl"
                          target="_blank">Instagram</a></ng-container>
                      <ng-container *ngIf="productData?.sellerInformation?.fbUrl"><br /><a
                          *ngIf="productData?.sellerInformation?.fbUrl"
                          [href]="'http://' + productData?.sellerInformation?.fbUrl"
                          target="_blank">Facebook</a></ng-container>
                      <br />
                    </ng-container>
                    <ng-container *ngIf="!mainProductEnableMemberShop">
                      <b class="mt-4"> Seller Info </b>
                      <br />{{ productData?.sellerInformation?.sellerInfo || defaultSellerMsg }}
                    </ng-container>
                  </div>
                </div>
                <div tab6>
                  <app-product-faq-list [additionalFAQS]="productData?.faqInfos"
                    [categoryId]="-1"></app-product-faq-list>
                </div>
                <!-- <div tab4>
                  <ngb-datepicker
                    #dp
                    [minDate]="{
                      year: today.getFullYear(),
                      month: today.getMonth() + 1,
                      day: today.getDate() + 1
                    }"
                    [dayTemplate]="datePicker"
                    outsideDays="hidden"
                  >
                  </ngb-datepicker>
                  <ng-template #datePicker let-date="date" let-focused="focused">
                    <div class="custom-day" [class.focused]="focused" [class.selected]="isSelected(date)">
                      {{ date.day }}
                    </div>
                  </ng-template>
                </div> -->
              </app-my-tabs>
            </div>
            <p class="w-100 text-center my-1"
              style="color: var(--primary); font-size: 0.8em; font-weight: bold; text-transform: none">Data is gathered
              from contributors from the local community from publicly available information.</p>

            <div *ngIf="roleService?.roles?.userType?.includes('ADMIN')" style="color: var(--secondary)" class="m-3">
              Login Because of product: {{ productData?.loginBecauseOfProductCount + "" }}</div>
            <div *ngIf="isLogin == 0 && mainProductEnableMemberShop && showLoginErr">
              <div class="alert alert-danger mt-2" role="alert" id="login-err">
                <div class="d-flex flex-column flex-md-row justify-content-between">
                  <span class="my-auto"> <i class="fa-solid fa-exclamation-circle"></i> Please log in first if you want
                    to {{ loginErrorReason }}. </span>
                  <button class="btn btn-sm btn-primary" (click)="loginHere()">Login Here !</button>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<div class="modal-footer fixed-position" *ngIf="screenWidth < 767" [class.p-0]="!isLogin">
  <div class="content d-flex flex-column" style="gap: 1em">
    <div *ngIf="!isUserDisabled && !productData?.seller?.isDisabled && productData?.type !== 'promote'">
      <button *ngIf="showChatNow" class="button-3 secondary" (click)="handleChatNow()"><i
          class="fa-solid fa-comment-dots"></i> Chat Now</button>
      <button class="button-3"
        *ngIf="isLogin && !productData?.isOwner && !productData?.isBooked && productData?.seller?.turnOffWhatsapp === 1"
        (click)="openBookNowBox()"><i class="fa-brands fa-whatsapp"></i> Book now ({{ remainingClickBook() }})</button>
      <button class="button-3" *ngIf="isLogin && productData?.isOwner"><i class="fa-brands fa-whatsapp"></i> {{
        productData?.remainingBookTimes }} Bookings Left</button>
      <button class="button-3 success"
        *ngIf="isLogin && (productData?.isBooked || productData?.seller?.buyerContact === 0) && productData?.seller?.w_phone_number"
        (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
      <button class="button-3 mt-3" (click)="handleTelegram(productData?.id)"
        *ngIf="isLogin && productData?.roleName?.includes('SUPER SELLER') && productData?.seller?.allowBookDriver"><i
          class="fa-brands fa-telegram"></i> Book Driver</button>
      <button class="button-3 mt-3" *ngIf="isLogin && showTelegramButton"
        (click)="openTelegramAccount(productData?.seller?.w_phone_number)"><i class="fa-brands fa-telegram"></i> Chat on
        Telegram</button>
    </div>
    <div
      *ngIf="isLogin && !isUserDisabled && !productData?.seller?.isDisabled && productData?.type == 'promote' && productData?.shoutContact && !(productData?.shoutContactRelation | nullCheck)">
      <button class="button-3 success"
        *ngIf="(productData?.isBooked || productData?.seller?.buyerContact === 0) && productData?.seller?.w_phone_number"
        (click)="redirectLink()"><i class="fa-brands fa-whatsapp"></i> WhatsApp ({{ remainingClickBook(1) }})</button>
    </div>
    <div class="bottom-actions" *ngIf="!isLogin">
      <button class="mr-3 open-bookmarks-btn" (click)="openSaveBookMarks()">
        {{ bookmarkedProductsIds.size }}/10
        <i class="fa fa-book ml-1"></i>
      </button>

      <!-- <div class="d-flex mr-2 align-items-center">
        <input type="checkbox" style="accent-color: red" [checked]="!bookmarkedProductsIds.has(productData?.id)" 
        [id]="'notinterested-' + productData?.name" (click)="$event.target.checked ?  removeProductFromBookmarks(productData) : addProductToBookmarks(productData)  "/>
        <label class="m-0 ml-2" [for]="'notinterested-' + productData?.name" style="color: red;">Not Interested</label>
      </div>  -->
      <button class="my-button-3 p-2" style="border-radius: 20px; font-size: 0.8rem" (click)="redirectLink(true)">Book
        Now</button>

      <div class="d-flex align-items-center">
        <input type="checkbox" style="accent-color: green"
          (click)="$event.target.checked ? addProductToBookmarks(productData) : removeProductFromBookmarks(productData)"
          [checked]="bookmarkedProductsIds.has(productData?.id)" [id]="'interested-' + productData?.name" />
        <label class="m-0 ml-2" [for]="'interested-' + productData?.name" style="color: green">Interested</label>
      </div>

      <!-- <a style="color: var(--secondary); " [href]="'https://wa.me/' + productData?.shoutContact" target="_blank"> 
        <i class="fa-brands fa-whatsapp" style="font-size: 1.1rem"></i> WhatsApp </a> -->
    </div>
    <div class="dropdown-product menu-top ml-auto" *ngIf="isLogin == 1">
      <div class="my-btn-list" *ngIf="roleService.roles?.level?.includes('MEMBER_VERIFIED_USER')"
        (click)="productData.showDropdown = !productData?.showDropdown">
        <i class="fa-solid fa-ellipsis-v text-dark"></i>
      </div>
      <div *ngIf="productData?.showDropdown" class="dropdown-product-detail bg-white"
        (mouseleave)="productData.showDropdown = false">
        <div class="dropdown-product-detail__item" (click)="openReportModal(reportsPopup)"
          *ngIf="productData?.showDropdown"><i class="fa-regular fa-flag"></i> Report</div>
        <div class="dropdown-product-detail__item suggest-shepherd" (click)="openSuggestModal(suggestionsPopup)"
          *ngIf="productData?.showDropdown"><i class="fa-regular fa-lightbulb pr-1"></i> Suggest</div>
        <div class="dropdown-product-detail__item" (click)="handleHideProduct()"
          *ngIf="productData?.showDropdown && mainProductEnableMemberShop"><i class="fa-regular fa-eye-slash"></i>
          Hide({{ productData?.hiddenBy?.length }})</div>
        <ng-container *ngIf="mainProductEnableMemberShop && roleService?.roles?.users?.includes('MEMBER_SHOP_PRODUCT')">
          <div class="dropdown-product-detail__item" (click)="editMemberProduct()"
            *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('EDIT')"><i class="fa fa-pencil"></i>
            Edit</div>
          <div class="dropdown-product-detail__item" (click)="deleteMemberProduct()"
            *ngIf="roleService.roles?.permissions['MEMBER_SHOP_PRODUCT']?.includes('DELETE')"><i
              class="fa fa-trash"></i> Delete</div>
        </ng-container>
        <div class="dropdown-product-detail__item" (click)="attachMemberProduct(AttachMemberProduct, productData?.id)"
          *ngIf="roleService.roles?.users?.includes('ATTACH_PRODUCT')"><i class="fa fa-trash"></i> Attach</div>
        <div class="dropdown-product-detail__item" (click)="deleteProductsAttachment()"
          *ngIf="roleService.roles?.users?.includes('ATTACH_PRODUCT') && productData && productData?.attachmentProductsKey">
          <i class="fa fa-trash"></i> Delete Attach</div>
        <div class="dropdown-product-detail__item" (click)="shareContent()"><i class="fa fa-share-alt"></i> Share
          Product</div>
      </div>
    </div>
  </div>
</div>

<ng-template #AttachMemberProduct let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Attach Product</h2>
    <div style="color: var(--primary)">Product</div>
    <section class="attach">
      <div class="attach__card" *ngFor="let list of memberProductList">
        <common-product-card-view [list]="list" [isCommunityProduct]="true"></common-product-card-view>
        <div class="attach__card--option">
          <select class="form-control" [(ngModel)]="endTime">
            <option value="30">30 Days</option>
            <option value="60">60 Days</option>
            <option value="">Endless</option>
          </select>
          <button class="my-button-3 secondary" (click)="attachProduct(list?.id)"><i
              class="fa-solid fa-save"></i>Attach</button>
        </div>
      </div>
    </section>
  </div>
</ng-template>

<ng-template #reportsPopup let-modal>
  <div class="bottom-sheet-reports">
    <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="my-modal__body">
      <h2 class="title">Report</h2>
      <div class="mt-2 mb-1" style="color: var(--primary)">Report Something Suspicious :</div>

      <div class="form-group">
        <label for="">Report Type</label>
        <select [(ngModel)]="reportType" id="" class="form-control">
          <option value="Spam">Spam</option>
          <option value="Wrong Info">Wrong Info</option>
          <option value="Repeated">Repeated</option>
          <option value="Out of business">Out of business</option>
          <option value="Offensive language">Offensive language</option>
          <option value="Offensive image">Offensive image</option>
          <option value="Seller Unresponsive">Seller Unresponsive</option>
          <option value="Seller is Rude">Seller is Rude</option>
          <option value="Seller is a Lowballer">Seller is a Lowballer</option>
        </select>
      </div>
      <div class="form-group">
        <textarea class="form-control" placeholder="Enter details" id="exampleFormControlTextarea1" maxlength="500"
          [(ngModel)]="memberMessage" rows="6"></textarea>
      </div>
      <button class="d-flex ml-auto my-button-3" (click)="submitReport()">Submit <i class="fa fa-gavel"
          aria-hidden="true"></i></button>
    </div>
  </div>
</ng-template>

<ng-template #memberLinkPopup let-modal>
  <div class="modal-body referral-modal">
    <div class="add_cattt">
      <h2>MEMBER INFO</h2>
      <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img"
        (click)="modal.dismiss('Cross click')" />
    </div>
    <!-- <div class="gold-membership">
        <div>
          <img loading="lazy" src="../../../../assets/images/GoldMember.png" alt="img">
          <p>Gold</p>
        </div>
      </div> -->
    <div class="referral-link">
      <h6>
        <span *ngIf="isTypeReferral == 'referral'">REFERRAL LINK</span>
        <span *ngIf="isTypeReferral == 'store'">PROFILE LINK</span>
      </h6>
      <div class="">
        <a class="referral-title" href="{{ refer_friend_link }}" target="_blank">
          <p class="ref_link">{{ refer_friend_link }}</p>
        </a>
      </div>
      <div class="mt-4">
        <div class="cart_btn">
          <a class="confirm_button" (click)="copyReferralLink()">
            <img loading="lazy" src="../../../../assets/images/copy-icon.svg" alt="img" />
            Copy</a>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #suggestionsPopup let-modal>
  <div class="bottom-sheet-suggestions">
    <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="my-modal__body">
      <h2 class="title">Suggestions</h2>
      <div class="form-group">
        <textarea class="form-control" placeholder="Enter Your Suggestions" id="exampleFormControlTextarea1"
          maxlength="500" [(ngModel)]="memberMessage" rows="6"></textarea>
      </div>
      <button class="d-flex ml-auto my-button-3" (click)="submitSuggestion()">Submit <i class="fa fa-thumbs-up"
          aria-hidden="true"></i></button>
    </div>
  </div>
</ng-template>

<ng-template #HolidayPopup let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="holiday-header">Holiday</h2>
    <div class="holiday-container">
      <ngb-datepicker #dp [minDate]="{
          year: today.getFullYear(),
          month: today.getMonth() + 1,
          day: today.getDate() + 1,
        }" [dayTemplate]="datePicker" outsideDays="hidden">
      </ngb-datepicker>
      <ng-template #datePicker let-date="date" let-focused="focused">
        <div class="custom-day" [class.focused]="focused" [class.selected]="isSelected(date)">
          {{ date.day }}
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #suggestChangeModal>
  <div class="bottom-sheet-suggest-change">
    <div class="my-modal__close" (click)="closeSuggestChangeModal()">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="my-modal__body">
      <div class="d-flex flex-column align-items-center p-1 position-relative w-100" style="overflow: auto">
        <!-- Tabs -->
        <div class="w-100 d-flex justify-content-start mb-4" style="overflow-x: auto">
          <button (click)="activeSuggestionChangeModalTab = 1"
            class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 1 ? 'dark' : 'light' }}">Questions
            Before</button>
          <button (click)="activeSuggestionChangeModalTab = 6"
            class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 6 ? 'dark' : 'light' }}">Questions After</button>
          <button (click)="activeSuggestionChangeModalTab = 2"
            class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 2 ? 'dark' : 'light' }}"
            *ngIf="productData?.foodSpecs?.length">Price</button>
          <button (click)="activeSuggestionChangeModalTab = 3"
            class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 3 ? 'dark' : 'light' }}">Images</button>
          <button (click)="activeSuggestionChangeModalTab = 4"
            class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 4 ? 'dark' : 'light' }}"
            *ngIf="productData?.ratings?.length">Review Info</button>
          <button (click)="activeSuggestionChangeModalTab = 5"
            class="btn btn-sm btn-{{ activeSuggestionChangeModalTab == 5 ? 'dark' : 'light' }}">Description</button>
        </div>
        <ng-container *ngIf="activeSuggestionChangeModalTab == 6">
          <p class="title-header my-2">Questions After</p>
          <p class="title-header my-2">Are you satified with the service?</p>

          <div class="w-100 d-flex mt-2 justify-content-center" style="gap: 2em">
            <button [class.active]="isSatisfiedAfter" (click)="isSatisfiedAfter = 1" class="card-sub-cate">
              <span class="card-sub-cate__title">Yes</span>
            </button>

            <button (click)="isSatisfiedAfter = 2" class="card-sub-cate" [class.active]="!isSatisfiedAfter">
              <span class="card-sub-cate__title">No</span>
            </button>
          </div>
        </ng-container>

        <!-- Tab 1: Questions -->
        <ng-container *ngIf="activeSuggestionChangeModalTab == 1">
          <p class="title-header my-2">Questions Before</p>
          <ng-container *ngFor="let option of suggestions; index as j">
            <ng-container
              *ngIf="(nonFoodIndexes.includes(j) || productIsFood(productData)) && (showMoreSuggestionInfos || j < 4)">
              <p class="title-header my-2">{{ option.title }}</p>
              <div class="d-flex flex-wrap justify-content-center" style="gap: 1em">
                <button (click)="option.value = i + 1" [class.active]="option.value == i + 1"
                  *ngFor="let altValue of option.options; index as i" class="card-sub-cate">
                  <span class="card-sub-cate__title">{{ altValue }}</span>
                </button>
              </div>
            </ng-container>
            <button *ngIf="j == 3 && productIsFood(productData)" class="btn btn-secondary my-3"
              (click)="showMoreSuggestionInfos = !showMoreSuggestionInfos">
              <i [ngClass]="showMoreSuggestionInfos ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
              {{ showMoreSuggestionInfos ? "Hide More Info" : "Show More Info" }}
            </button>
          </ng-container>
        </ng-container>

        <!-- Tab 2: Price -->
        <ng-container *ngIf="activeSuggestionChangeModalTab == 2">
          <div class="d-flex flex-column w-100" style="font-size: 1rem; color: black">
            <ng-container *ngFor="let variants of productData?.foodSpecs; index as i">
              <div class="d-flex justify-content-between py-2" style="border-bottom: 1px solid #d9d2d2">
                <div class="w-25 mr-2" *ngIf="variants.image">
                  <img [src]="imgUrl + variants.image" class="w-100 shadow-sm" style="aspect-ratio: 1/1" />
                </div>
                <div class="d-flex flex-column align-items-start" style="width: 80%">
                  <span *ngIf="variants.value">
                    {{ variants.value }}
                    <button
                      (click)="likedVariants.has(variants.value) ? likedVariants.delete(variants.value) : likedVariants.add(variants.value)"
                      class="t-btn">
                      <i [class.fa-solid]="likedVariants.has(variants.value)"
                        [class.fa-regular]="!likedVariants.has(variants.value)" class="fa-heart"
                        style="color: var(--secondary)"></i>
                      Popular
                    </button>
                  </span>
                  <span *ngIf="variants.nKey && variants.nKey !== '0'" style="color: rgb(94, 92, 92)">{{ variants.nKey
                    }}</span>
                  <label class="t-btn" style="color: var(--secondary); font-size: 0.7em; text-decoration: underline">
                    <input type="checkbox" [checked]="flaggedVariants.has(variants.value)"
                      (change)="!$event.target.checked ? flaggedVariants.delete(variants.value) : flaggedVariants.add(variants.value)"
                      style="accent-color: var(--secondary)" /> This Variant Doesn't Exist Any Longer </label>
                </div>
                <div class="d-flex flex-column">
                  <div *ngIf="variants.key && variants.key !== '0'" style="color: var(--primary); font-size: 0.9rem">${{
                    variants.key }}</div>
                  <input type="number" placeholder="Update $" [(ngModel)]="variationPriceSuggestion[variants.value]"
                    class="form-control mt-2" />
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- Tab 3: Images -->
        <ng-container *ngIf="activeSuggestionChangeModalTab == 3">
          <p class="title-header my-2">Suggest Photo Changes</p>
          <div class="d-flex w-100 mb-4">
            <ng-container *ngFor="let i of [1, 2, 3, 4]">
              <span class="position-relative sugg-img mr-3" *ngIf="productData?.['food_image_'+i]">
                <img class="suggest-change-img mr-3" [src]="imgUrl + productData?.['food_image_'+i]" />
              </span>
            </ng-container>
          </div>
          <div class="d-flex w-100 mb-2">
            <ng-container *ngFor="let i of [0, 1, 2, 3]">
              <span class="position-relative sugg-img mr-3">
                <ng-container *ngIf="encodedSuggestImages[i]">
                  <img class="suggest-change-img mr-3" [src]="encodedSuggestImages[i]" />
                  <span class="delete-img"><i class="fa fa-trash" (click)="deleteSuggestImage(i)"></i></span>
                </ng-container>
              </span>
            </ng-container>
          </div>
          <img class="suggest-change-img mr-3 shadow" src="../../assets/images/uploadd2.png"
            (click)="selectSuggestChangeImage(i)" />
          <input type="file" (change)="setImageOfSuggestImages($event)" id="imgSugSelector"
            style="visibility: hidden; width: 0" multiple />
        </ng-container>

        <!-- Tab 4: Review Info -->
        <ng-container *ngIf="activeSuggestionChangeModalTab == 4">
          <div class="w-100">
            <div *ngTemplateOutlet="prodReviews"></div>
          </div>
        </ng-container>

        <!-- Tab 5: Description -->
        <ng-container *ngIf="activeSuggestionChangeModalTab == 5">
          <div class="d-flex flex-column w-100">
            <p class="my-2">
              {{ productData?.description.slice(0, isReviewShowingFullDescritpion ? productData?.description?.length :
              50) }}
              <span *ngIf="!isReviewShowingFullDescritpion && productData?.description?.length > 50">...</span>
            </p>
            <button class="t-btn" *ngIf="productData?.description?.length > 50"
              (click)="isReviewShowingFullDescritpion = !isReviewShowingFullDescritpion">
              {{ isReviewShowingFullDescritpion ? "Less" : "More" }}
            </button>
            <p class="title-header mb-1">Suggest Description</p>
            <textarea [(ngModel)]="suggestDescrChange" placeholder="Suggest changes to description"
              class="form-control"></textarea>
          </div>
        </ng-container>

        <!-- Submit button -->
        <div class="w-100 d-flex justify-content-center mt-4 position-sticky">
          <button class="my-button-3" (click)="submitReview()"><i class="fa fa-check"></i> Submit</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>